var _path, _path2, _path3, _path4, _path5, _g, _path6, _path7, _path8, _g2, _path9, _path10, _path11, _g3, _path12, _path13, _path14, _path15, _path16, _path17, _g4, _path18, _path19, _path20, _g5, _path21, _path22, _path23, _g6, _path24, _path25, _path26, _g7, _path27, _path28, _path29, _g8, _path30, _path31, _path32, _g9, _path33, _path34, _path35, _g10, _path36, _path37, _path38, _g11, _path39, _path40, _path41, _g12, _path42, _path43, _path44, _g13, _path45, _path46, _path47, _g14, _path48, _path49, _path50, _g15, _path51, _path52, _path53, _g16, _path54, _path55, _path56, _g17, _path57, _path58, _path59, _g18, _path60, _path61, _path62, _g19, _path63, _path64, _path65, _g20, _path66, _path67, _path68, _g21, _path69, _path70, _path71, _g22, _path72, _path73, _path74, _g23, _path75, _path76, _path77, _g24, _path78, _path79, _path80, _g25, _path81, _path82, _path83, _g26, _path84, _path85, _path86, _g27, _path87, _path88, _path89, _g28, _path90, _path91, _path92, _g29, _path93, _path94, _path95, _g30, _path96, _path97, _path98, _g31, _path99, _path100, _path101, _g32, _path102, _path103, _path104, _g33, _path105, _path106, _path107, _g34, _path108, _path109, _path110, _g35, _path111, _path112, _path113, _g36, _path114, _path115, _path116, _g37, _path117, _path118, _path119, _g38, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 97,
    viewBox: "0 0 50 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3780_17935)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.9686 18.3644C44.9305 19.1851 44.8583 20.0045 44.7644 20.8153C44.7532 20.9124 44.742 21.0095 44.7307 21.1067C44.6272 22.0031 44.5264 22.9007 44.4264 23.7997C44.3276 24.6863 44.2295 25.574 44.131 26.4618C44.0316 27.3605 43.9315 28.2599 43.829 29.1592C43.7292 30.0407 43.6275 30.9222 43.5225 31.8035C43.4005 32.8241 43.2747 33.8439 43.1425 34.8633C43.0307 35.7259 42.9142 36.588 42.7918 37.4489C42.6604 38.3744 42.5222 39.2989 42.3763 40.2217C42.2445 41.0533 42.106 41.8837 41.9596 42.7123C41.7758 43.7524 41.5797 44.7902 41.3689 45.8244C41.2086 46.6123 41.0398 47.3984 40.8613 48.1821C40.861 48.1834 40.8607 48.1847 40.8604 48.1861C40.1946 51.1124 39.3095 54.1194 37.2874 56.337C35.7742 57.9967 33.7455 59.0923 31.5655 59.7597C29.6839 60.3362 27.6895 60.5935 25.8149 60.621C23.1238 60.6604 20.3071 60.3749 17.616 59.6671C15.7866 59.1861 14.0156 58.5101 12.3814 57.6087C12.3051 57.5668 12.2288 57.5242 12.1532 57.4809C11.2597 56.9731 10.4095 56.3955 9.61528 55.7446C9.57037 55.7076 9.52507 55.671 9.48054 55.6333C8.96674 55.2031 8.47708 54.7418 8.01555 54.2473C7.75355 53.9664 7.50072 53.6754 7.25717 53.3734C6.41401 52.3273 5.84936 51.2364 5.49585 50.113C4.61396 47.3122 5.04323 44.3081 5.73772 41.2813C5.78328 41.0818 5.83025 40.8821 5.87814 40.6824C5.99249 40.2052 6.10645 39.7284 6.2208 39.2513C6.42265 38.4068 6.62489 37.5623 6.82701 36.7175C6.98627 36.0514 7.14592 35.385 7.30519 34.7186C7.50072 33.9018 7.69599 33.0851 7.89165 32.2683L8.36802 30.2773C8.56962 29.4352 8.77108 28.5922 8.97268 27.7501C9.13001 27.0938 9.28695 26.4374 9.44389 25.7813C9.64071 24.9589 9.83727 24.1365 10.0342 23.3145C10.1909 22.6596 10.3478 22.0044 10.5044 21.3499C10.5146 21.3059 10.5256 21.262 10.5358 21.218C10.7175 20.4597 10.8962 19.6989 11.0756 18.9376C11.2306 18.2811 11.3856 17.624 11.5428 16.967C11.7349 16.1632 11.9304 15.359 12.1327 14.5572C12.2998 13.8924 12.4716 13.2292 12.6501 12.5678C12.8 12.0118 12.9544 11.4573 13.1146 10.9049C13.2266 10.5183 13.3412 10.1328 13.4592 9.74853C13.5504 9.45182 13.6485 9.16504 13.7536 8.88781C14.4464 7.06106 15.4403 5.64859 16.6833 4.5522C17.5169 3.81641 18.4631 3.22311 19.5049 2.74261C20.0725 2.481 20.6685 2.25294 21.2907 2.0538C22.0351 1.81516 22.8165 1.61795 23.6309 1.45404C23.9712 1.38538 24.3171 1.32253 24.6687 1.26509C24.8006 1.24328 24.9324 1.22341 25.0645 1.20431C25.8499 1.09202 26.6464 1.0262 27.4464 1.00774C28.0322 0.993804 28.6203 1.00503 29.2068 1.04143C29.8748 1.08299 30.5413 1.15707 31.2021 1.26406C32.0571 1.40216 32.903 1.59511 33.729 1.84368C34.3418 2.02734 34.9439 2.24146 35.5313 2.48629C39.1806 4.00446 42.2672 6.69129 43.8554 10.5612C44.3458 11.756 44.6524 13.0049 44.8235 14.2799C45.0036 15.6234 45.0333 16.9958 44.9686 18.3644Z",
    fill: "#FFBF08"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9686 18.3638C44.9305 19.1845 44.8583 20.004 44.7644 20.8147C44.7532 20.9118 44.742 21.009 44.7307 21.1062C44.6272 22.0025 44.5264 22.9001 44.4264 23.7992C44.3275 24.6857 44.2295 25.5734 44.131 26.4612C44.0316 27.3599 43.9315 28.2593 43.829 29.1587C43.7292 30.0402 43.6275 30.9217 43.5225 31.8029C43.4005 32.8235 43.2747 33.8434 43.1425 34.8627C43.0307 35.7254 42.9142 36.5874 42.7918 37.4484C42.6604 38.3739 42.5222 39.2984 42.3762 40.2212C42.2445 41.0527 42.106 41.8831 41.9596 42.7117C41.7758 43.7518 41.5797 44.7896 41.3689 45.8238C41.2086 46.6117 41.0398 47.3978 40.8613 48.1815C40.861 48.1828 40.8607 48.1841 40.8604 48.1855C40.1946 51.1119 39.3095 54.1188 37.2874 56.3365C35.7742 57.9961 33.7455 59.0917 31.5655 59.7591C29.6839 60.3356 27.6895 60.593 25.8149 60.6205C23.1238 60.6598 20.3071 60.3743 17.616 59.6666C15.7866 59.1855 14.0156 58.5095 12.3814 57.6081C12.3051 57.5662 12.2288 57.5236 12.1532 57.4804C11.2597 56.9725 10.4095 56.3949 9.61528 55.7441C9.57037 55.707 9.52507 55.6704 9.48054 55.6327C8.96674 55.2025 8.47708 54.7413 8.01555 54.2467C7.75355 53.9658 7.50072 53.6748 7.25717 53.3728C6.41401 52.3267 5.84936 51.2358 5.49585 50.1124C4.61396 47.3116 5.04323 44.3075 5.73772 41.2808C5.78328 41.0812 5.83025 40.8816 5.87814 40.6818C5.99249 40.2046 6.10645 39.7279 6.2208 39.2507C6.42265 38.4063 6.62489 37.5617 6.82701 36.717C6.98627 36.0509 7.14592 35.3844 7.30519 34.718C7.50072 33.9012 7.69599 33.0845 7.89165 32.2678L8.36802 30.2767C8.56962 29.4346 8.77108 28.5917 8.97268 27.7495C9.13001 27.0933 9.28695 26.4368 9.44389 25.7807C9.64071 24.9583 9.83727 24.1359 10.0342 23.3139C10.1909 22.659 10.3478 22.0038 10.5044 21.3493C10.5146 21.3053 10.5256 21.2614 10.5358 21.2174C10.7175 20.4592 10.8962 19.6983 11.0756 18.937C11.2306 18.2806 11.3856 17.6234 11.5428 16.9665C11.7349 16.1627 11.9304 15.3585 12.1327 14.5566C12.2998 13.8918 12.4716 13.2287 12.6501 12.5672C12.8 12.0112 12.9544 11.4568 13.1146 10.9044C13.2266 10.5177 13.3412 10.1322 13.4592 9.74796C13.5504 9.45125 13.6485 9.16447 13.7536 8.88724C14.4464 7.06048 15.4403 5.64802 16.6833 4.55163C17.5169 3.81584 18.4631 3.22254 19.5049 2.74204C20.0725 2.48043 20.6685 2.25237 21.2907 2.05323C22.0351 1.81459 22.8165 1.61738 23.6309 1.45347C23.9712 1.38481 24.3171 1.32196 24.6687 1.26452C24.8006 1.24271 24.9324 1.22284 25.0645 1.20373C25.8499 1.09145 26.6464 1.02563 27.4464 1.00717C28.0322 0.993232 28.6203 1.00446 29.2068 1.04086C29.8748 1.08241 30.5413 1.1565 31.2021 1.26349C32.0571 1.40159 32.903 1.59454 33.729 1.84311C34.3418 2.02677 34.9439 2.24088 35.5313 2.48572C39.1806 4.00388 42.2672 6.69072 43.8554 10.5607C44.3457 11.7554 44.6524 13.0044 44.8235 14.2794C45.0036 15.6228 45.0333 16.9952 44.9686 18.3638Z",
    stroke: "#333333",
    strokeOpacity: 0.8,
    strokeWidth: 0.591478,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 59,
    width: 17,
    height: 12
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8398 59.6475H31.5669V70.9141H15.8398V59.6475Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 59,
    width: 17,
    height: 12
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4111 67.4423C29.0587 68.7028 28.2069 70.3043 27.0486 70.747C26.8182 70.8349 26.5255 70.8798 26.2037 70.8957H26.2027C24.9025 70.9584 23.1306 70.5424 23.1306 70.5424C21.7677 69.4525 23.1306 64.7093 23.1306 64.7093H19.9961C18.2245 65.6895 18.7016 69.7247 18.7016 69.7247C12.9777 70.3383 17.615 59.668 17.615 59.668C20.3061 60.3758 23.1227 60.6612 25.8138 60.6219C27.6885 60.5944 29.6829 60.337 31.5645 59.7605L28.4111 67.4423Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 59,
    width: 17,
    height: 12
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4111 67.4433C29.0587 68.7037 28.2069 70.3053 27.0486 70.748C26.8182 70.8359 26.5255 70.8808 26.2037 70.8967H26.2027C24.9025 70.9594 23.1306 70.5434 23.1306 70.5434C21.7677 69.4535 23.1306 64.7103 23.1306 64.7103H19.9961C18.2245 65.6905 18.7016 69.7257 18.7016 69.7257C12.9777 70.3392 17.615 59.6689 17.615 59.6689C20.3061 60.3767 23.1227 60.6622 25.8138 60.6228C27.6885 60.5954 29.6829 60.338 31.5645 59.7615L28.4111 67.4433Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_3780_17935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9785 59.6689V70.9594H31.5653V59.6689H12.9785Z",
    fill: "#333333"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 64,
    width: 6,
    height: 9
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6152 64.7021H23.1417V72.9952H18.6152V64.7021Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 64,
    width: 6,
    height: 9
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.132 70.5397C22.5185 71.0848 22.723 72.9929 22.723 72.9929H18.703V69.7219C18.703 69.7219 18.226 65.6868 19.9975 64.7065H23.132C23.132 64.7065 21.7691 69.4497 23.132 70.5397Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 64,
    width: 6,
    height: 9
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.132 70.5397C22.5185 71.0848 22.723 72.9929 22.723 72.9929H18.703V69.7219C18.703 69.7219 18.226 65.6868 19.9975 64.7065H23.132C23.132 64.7065 21.7691 69.4497 23.132 70.5397Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_3780_17935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2266 64.7065V72.9929H23.1326V64.7065H18.2266Z",
    fill: "#FF6739"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 70,
    width: 14,
    height: 13
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M16.666 70.5176H29.1221V82.3459H16.666V70.5176Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 70,
    width: 14,
    height: 13
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M29.06 80.2154C28.976 80.8858 28.7546 81.3044 28.2082 81.6963C28.0879 81.7822 27.9528 81.8668 27.7992 81.9527C26.9474 82.4297 21.2579 82.4297 19.18 82.1572C18.3989 82.0548 17.8683 81.8466 17.5098 81.6266C16.9144 81.2611 16.7951 80.8627 16.7951 80.8627C16.7951 80.8627 16.5222 73.9467 16.7951 72.7202C17.0673 71.4938 18.7028 71.3573 18.7028 71.3573V72.9928H22.7229C22.7229 72.9928 22.5183 71.0847 23.1319 70.5396C23.1319 70.5396 24.9038 70.9555 26.204 70.8928H26.205C28.6426 71.1185 29.06 72.6522 29.06 72.6522C29.06 72.6522 29.1621 79.3977 29.06 80.2154Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 70,
    width: 14,
    height: 13
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0581 80.2178C28.974 80.8882 28.7527 81.3069 28.2062 81.6987C28.0859 81.7847 27.9508 81.8692 27.7972 81.9552C26.9454 82.4322 21.2559 82.4322 19.178 82.1596C18.3969 82.0573 17.8664 81.8491 17.5078 81.629C16.9124 81.2635 16.7932 80.8651 16.7932 80.8651C16.7932 80.8651 16.5202 73.9491 16.7932 72.7226C17.0654 71.4963 18.7009 71.3597 18.7009 71.3597V72.9952H22.7209C22.7209 72.9952 22.5164 71.0872 23.1299 70.542C23.1299 70.542 24.9018 70.958 26.202 70.8952H26.203C28.6407 71.121 29.0581 72.6546 29.0581 72.6546C29.0581 72.6546 29.1601 79.4001 29.0581 80.2178Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_3780_17935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5215 70.542V82.4322H29.1614V70.542H16.5215Z",
    fill: "#333333"
  }))))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4083 60.6038C26.2656 60.9333 22.9666 70.9084 27.4779 70.5202",
    stroke: "#333333",
    strokeOpacity: 0.8,
    strokeWidth: 0.591478,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2082 81.6983V88.3566C27.3637 88.4127 26.5115 88.4411 25.6529 88.4411C22.858 88.4411 20.1328 88.1399 17.5098 87.5679V81.6289C17.8683 81.8487 18.3989 82.0569 19.1796 82.1592C21.2581 82.4318 26.9474 82.4318 27.7992 81.955C27.9525 81.8688 28.0883 81.7843 28.2082 81.6983Z",
    fill: "url(#paint0_linear_3780_17935)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2082 81.6977V88.3559C27.3637 88.412 26.5115 88.4404 25.6529 88.4404C22.858 88.4404 20.1328 88.1392 17.5098 87.5672V81.6282C17.8683 81.848 18.3989 82.0562 19.1796 82.1585C21.2581 82.4311 26.9474 82.4311 27.7992 81.9544C27.9525 81.8682 28.0883 81.7836 28.2082 81.6977Z",
    stroke: "#333333",
    strokeOpacity: 0.8,
    strokeWidth: 0.591478,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 10,
    width: 23,
    height: 50
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8945 10.8447H42.8993V59.678H20.8945V10.8447Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask10_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 10,
    width: 23,
    height: 50
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8907 10.8535C42.856 11.4704 42.8156 12.087 42.7746 12.7031C42.7308 13.3193 42.6874 13.9355 42.6391 14.551C42.5916 15.1669 42.5417 15.7824 42.4895 16.3977L42.4093 17.3205L42.3263 18.2433C42.2117 19.473 42.0914 20.7024 41.9599 21.9306L41.8614 22.852L41.7583 23.7729L41.6532 24.6933L41.5433 25.6135C41.2485 28.0668 40.9191 30.5164 40.554 32.961C40.3723 34.1835 40.1791 35.4043 39.9791 36.6242C39.9306 36.9294 39.877 37.2337 39.8258 37.5387L39.6705 38.4526L39.5159 39.3608L39.3669 40.2715L39.0682 42.0993C38.9657 42.7099 38.8607 43.3211 38.7463 43.9324C38.5178 45.1548 38.2547 46.3776 37.9177 47.5878C37.7476 48.1925 37.5622 48.7948 37.3478 49.3889L37.2675 49.6119L37.1836 49.8336L37.1417 49.9442L37.0981 50.0546L37.0098 50.275C36.948 50.421 36.8889 50.5681 36.8241 50.7128C36.7921 50.7852 36.7607 50.8581 36.7279 50.9302L36.6281 51.1466C36.4934 51.434 36.352 51.7189 36.1997 51.9987C36.1257 52.1395 36.0457 52.2776 35.9673 52.4163C35.9277 52.4854 35.8862 52.5535 35.8455 52.6222C35.8051 52.691 35.7642 52.7594 35.721 52.8264L35.5933 53.029L35.4609 53.2288L35.3944 53.3285L35.3258 53.4268C35.2798 53.4922 35.2349 53.5583 35.1879 53.6229C35.0928 53.7515 34.9996 53.8813 34.8995 54.0062C34.8497 54.069 34.8024 54.1335 34.7505 54.1945L34.5979 54.3799C33.7738 55.3599 32.7948 56.2143 31.7045 56.8761L31.6028 56.9389L31.4997 56.999L31.2928 57.1186L31.0831 57.2319C31.013 57.2696 30.9433 57.3079 30.8719 57.3427L30.6589 57.4494C30.5881 57.4854 30.5155 57.5171 30.4437 57.5508C30.3717 57.5839 30.3003 57.6189 30.2273 57.65L30.0089 57.7427C29.4254 57.9829 28.8343 58.1931 28.2357 58.3758C27.0363 58.7333 25.8168 58.9894 24.5933 59.184C23.3701 59.3822 22.1434 59.5265 20.916 59.668C22.1216 59.396 23.3322 59.1497 24.5286 58.8608C25.1263 58.7155 25.7219 58.5654 26.3098 58.3919C26.8976 58.2202 27.48 58.0355 28.0513 57.8243C28.6219 57.6125 29.1829 57.3783 29.7274 57.1177C30.2673 56.854 30.7917 56.5612 31.2833 56.2229L31.4677 56.0956L31.648 55.9639L31.7379 55.8978C31.768 55.8756 31.7967 55.8518 31.8265 55.8294L32.0025 55.6923C32.0607 55.646 32.1175 55.5979 32.1751 55.5505L32.2609 55.4795C32.2897 55.4558 32.3168 55.4306 32.3448 55.4062L32.5123 55.2592C32.5672 55.2092 32.6211 55.158 32.6756 55.1074L32.7572 55.0315L32.8365 54.9536L32.9952 54.7973L33.1491 54.6363L33.2257 54.5557L33.3004 54.4731C33.5016 54.2551 33.6905 54.0257 33.8746 53.7932L34.0101 53.6163C34.056 53.5579 34.098 53.4964 34.1419 53.4367C34.2304 53.3173 34.313 53.1938 34.3977 53.0716C34.4392 53.0101 34.4792 52.9473 34.5199 52.8852L34.5811 52.7916L34.6398 52.6969L34.7571 52.5072L34.8702 52.3142C34.9081 52.2505 34.9445 52.1854 34.9805 52.12C35.0165 52.0549 35.0534 51.9904 35.0888 51.9247C35.1582 51.7926 35.2296 51.6617 35.2953 51.5272C35.4304 51.2613 35.555 50.989 35.6759 50.7154C36.1571 49.6178 36.5254 48.4663 36.8337 47.2948C37.1387 46.1219 37.3821 44.9272 37.5969 43.7221C37.7049 43.1199 37.8061 42.5146 37.9046 41.9072L38.1992 40.0815C38.299 39.4719 38.4015 38.859 38.5095 38.2495L38.8283 36.4295L39.1406 34.6083L39.2946 33.6974L39.3715 33.2418L39.4471 32.7862C39.8519 30.3555 40.2422 27.9221 40.6241 25.486L40.7678 24.5728L40.9089 23.6589L41.1921 21.8308L41.7521 18.1729L42.3134 14.5134L42.5976 12.6832C42.694 12.0734 42.7888 11.4631 42.8907 10.8535Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask11_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 10,
    width: 23,
    height: 50
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8907 10.8525C42.856 11.4695 42.8156 12.086 42.7746 12.7021C42.7308 13.3183 42.6874 13.9346 42.6391 14.5501C42.5916 15.166 42.5417 15.7815 42.4895 16.3967L42.4093 17.3195L42.3263 18.2423C42.2117 19.472 42.0914 20.7015 41.9599 21.9296L41.8614 22.851L41.7583 23.7719L41.6532 24.6924L41.5433 25.6126C41.2485 28.0658 40.9191 30.5154 40.554 32.96C40.3723 34.1825 40.1791 35.4033 39.9791 36.6232C39.9306 36.9284 39.877 37.2328 39.8258 37.5377L39.6705 38.4516L39.5159 39.3598L39.3669 40.2705L39.0682 42.0983C38.9657 42.7089 38.8607 43.3201 38.7463 43.9314C38.5178 45.1539 38.2547 46.3766 37.9177 47.5868C37.7476 48.1915 37.5622 48.7938 37.3478 49.3879L37.2675 49.6109L37.1836 49.8327L37.1417 49.9433L37.0981 50.0536L37.0098 50.2741C36.948 50.42 36.8889 50.5672 36.8241 50.7118C36.7921 50.7842 36.7607 50.8572 36.7279 50.9292L36.6281 51.1456C36.4934 51.433 36.352 51.7179 36.1997 51.9977C36.1257 52.1385 36.0457 52.2766 35.9673 52.4153C35.9277 52.4844 35.8862 52.5525 35.8455 52.6212C35.8051 52.69 35.7642 52.7584 35.721 52.8254L35.5933 53.028L35.4609 53.2278L35.3944 53.3276L35.3258 53.4258C35.2798 53.4912 35.2349 53.5573 35.1879 53.622C35.0928 53.7505 34.9996 53.8803 34.8995 54.0053C34.8497 54.068 34.8024 54.1325 34.7505 54.1936L34.5979 54.3789C33.7738 55.3589 32.7948 56.2133 31.7045 56.8751L31.6028 56.938L31.4997 56.998L31.2928 57.1176L31.0831 57.2309C31.013 57.2686 30.9433 57.307 30.8719 57.3417L30.6589 57.4484C30.5881 57.4844 30.5155 57.5162 30.4437 57.5499C30.3717 57.5829 30.3003 57.6179 30.2273 57.649L30.0089 57.7418C29.4254 57.982 28.8343 58.1921 28.2357 58.3748C27.0363 58.7323 25.8168 58.9884 24.5933 59.183C23.3701 59.3813 22.1434 59.5256 20.916 59.667C22.1216 59.3951 23.3322 59.1487 24.5286 58.8598C25.1263 58.7145 25.7219 58.5644 26.3098 58.391C26.8976 58.2192 27.48 58.0345 28.0513 57.8233C28.6219 57.6115 29.1829 57.3773 29.7274 57.1167C30.2673 56.853 30.7917 56.5602 31.2833 56.2219L31.4677 56.0947L31.648 55.9629L31.7379 55.8968C31.768 55.8746 31.7967 55.8509 31.8265 55.8284L32.0025 55.6913C32.0607 55.645 32.1175 55.5969 32.1751 55.5495L32.2609 55.4785C32.2897 55.4548 32.3168 55.4296 32.3448 55.4052L32.5123 55.2582C32.5672 55.2083 32.6211 55.157 32.6756 55.1064L32.7572 55.0305L32.8365 54.9526L32.9952 54.7963L33.1491 54.6354L33.2257 54.5547L33.3004 54.4721C33.5016 54.2541 33.6905 54.0248 33.8746 53.7922L34.0101 53.6154C34.056 53.5569 34.098 53.4955 34.1419 53.4357C34.2304 53.3163 34.313 53.1928 34.3977 53.0706C34.4392 53.0092 34.4792 52.9463 34.5199 52.8842L34.5811 52.7907L34.6398 52.6959L34.7571 52.5062L34.8702 52.3133C34.9081 52.2495 34.9445 52.1844 34.9805 52.119C35.0165 52.054 35.0534 51.9894 35.0888 51.9237C35.1582 51.7916 35.2296 51.6607 35.2953 51.5262C35.4304 51.2604 35.555 50.988 35.6759 50.7144C36.1571 49.6169 36.5254 48.4654 36.8337 47.2939C37.1387 46.1209 37.3821 44.9262 37.5969 43.7211C37.7049 43.1189 37.8061 42.5136 37.9046 41.9063L38.1992 40.0805C38.299 39.471 38.4015 38.858 38.5095 38.2485L38.8283 36.4286L39.1406 34.6074L39.2946 33.6964L39.3715 33.2408L39.4471 32.7852C39.8519 30.3545 40.2422 27.9211 40.6241 25.4851L40.7678 24.5718L40.9089 23.6579L41.1921 21.8299L41.7521 18.172L42.3134 14.5124L42.5976 12.6823C42.694 12.0724 42.7888 11.4621 42.8907 10.8525Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_3780_17935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.916 10.8525V59.667H42.8907V10.8525H20.916Z",
    fill: "#333333"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 38,
    width: 10,
    height: 4
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M5.72852 38.4014H14.4511V41.3089H5.72852V38.4014Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask13_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 38,
    width: 10,
    height: 4
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4183 39.5134C14.3314 39.9955 13.8705 40.3157 13.3885 40.2295C13.1535 40.1901 11.3555 40.0606 9.02214 40.4345C8.0663 40.5876 6.91855 40.8454 5.73633 41.2791C5.78189 41.0796 5.82887 40.8799 5.87675 40.6802C5.9911 40.203 6.10506 39.7262 6.21941 39.2491C7.03444 39.0089 7.88962 38.8173 8.77641 38.6768C11.2131 38.2907 13.2398 38.3996 13.7024 38.483C14.1847 38.5695 14.5051 39.0311 14.4183 39.5134Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask14_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 38,
    width: 10,
    height: 4
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4183 39.5124C14.3314 39.9945 13.8705 40.3147 13.3885 40.2285C13.1535 40.1891 11.3555 40.0597 9.02214 40.4336C8.0663 40.5866 6.91855 40.8444 5.73633 41.2782C5.78189 41.0786 5.82887 40.879 5.87675 40.6792C5.9911 40.202 6.10506 39.7253 6.21941 39.2481C7.03444 39.0079 7.88962 38.8163 8.77641 38.6759C11.2131 38.2897 13.2398 38.3986 13.7024 38.482C14.1847 38.5685 14.5051 39.0301 14.4183 39.5124Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_3780_17935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.73633 38.2915V41.28H14.5051V38.2915H5.73633Z",
    fill: "#333333"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask15_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 33,
    width: 10,
    height: 4
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M6.82031 33.9727H15.1134V36.748H6.82031V33.9727Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask16_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 33,
    width: 10,
    height: 4
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M15.075 35.1067C14.9885 35.5888 14.5279 35.909 14.0458 35.8227C13.8105 35.7834 12.0126 35.6542 9.67885 36.0279C8.84007 36.1621 7.85377 36.3771 6.82617 36.7208C6.98544 36.0547 7.14509 35.3882 7.30435 34.7219C7.9889 34.5375 8.7003 34.3862 9.43312 34.2702C11.8701 33.8839 13.8968 33.9929 14.3593 34.0762C14.8418 34.1632 15.1622 34.6243 15.075 35.1067Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask17_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 33,
    width: 10,
    height: 4
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M15.075 35.1072C14.9885 35.5893 14.5279 35.9095 14.0458 35.8232C13.8105 35.7839 12.0126 35.6547 9.67885 36.0284C8.84007 36.1626 7.85377 36.3776 6.82617 36.7213C6.98544 36.0552 7.14509 35.3887 7.30435 34.7224C7.9889 34.5379 8.7003 34.3867 9.43312 34.2707C11.8701 33.8844 13.8968 33.9934 14.3593 34.0767C14.8418 34.1637 15.1622 34.6248 15.075 35.1072Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_3780_17935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.82617 33.8833V36.7202H15.1622V33.8833H6.82617Z",
    fill: "#333333"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask18_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 29,
    width: 10,
    height: 4
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M7.87695 29.5459H16.0709V32.2882H7.87695V29.5459Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask19_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 29,
    width: 10,
    height: 4
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0274 30.6935C15.9402 31.1756 15.4795 31.496 14.9975 31.4094C14.7619 31.3702 12.9642 31.2413 10.6309 31.6146C9.82283 31.7442 8.87744 31.9484 7.89062 32.2705L8.367 30.2795C9.0176 30.1083 9.69157 29.9673 10.3852 29.8572C12.8221 29.471 14.8492 29.5797 15.3114 29.6629C15.7934 29.7502 16.1143 30.2115 16.0274 30.6935Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask20_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 29,
    width: 10,
    height: 4
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0274 30.6955C15.9402 31.1775 15.4795 31.498 14.9975 31.4114C14.7619 31.3721 12.9642 31.2432 10.6309 31.6166C9.82283 31.7462 8.87744 31.9503 7.89062 32.2725L8.367 30.2814C9.0176 30.1103 9.69157 29.9692 10.3852 29.8591C12.8221 29.473 14.8492 29.5816 15.3114 29.6649C15.7934 29.7521 16.1143 30.2134 16.0274 30.6955Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_3780_17935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.89062 29.4697V32.2692H16.1143V29.4697H7.89062Z",
    fill: "#333333"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask21_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 25,
    width: 9,
    height: 3
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M8.9668 25.1523H16.7973V27.7625H8.9668V25.1523Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask22_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 25,
    width: 9,
    height: 3
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7735 26.2803C16.6865 26.7625 16.2256 27.0826 15.7439 26.9963C15.5087 26.957 13.7106 26.8282 11.377 27.2015C10.6613 27.3162 9.83802 27.4896 8.97266 27.7514C9.12998 27.0951 9.28692 26.4387 9.44387 25.7825C9.99122 25.6483 10.5543 25.5353 11.1311 25.4441C13.5682 25.0578 15.5949 25.1666 16.0574 25.2501C16.5399 25.3371 16.86 25.7982 16.7735 26.2803Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask23_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 25,
    width: 9,
    height: 3
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7735 26.2813C16.6865 26.7635 16.2256 27.0835 15.7439 26.9973C15.5087 26.9579 13.7106 26.8291 11.377 27.2025C10.6613 27.3171 9.83802 27.4906 8.97266 27.7523C9.12998 27.096 9.28692 26.4396 9.44387 25.7835C9.99122 25.6493 10.5543 25.5363 11.1311 25.4451C13.5682 25.0588 15.5949 25.1676 16.0574 25.2511C16.5399 25.3381 16.86 25.7992 16.7735 26.2813Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_3780_17935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.97266 25.0566V27.7502H16.86V25.0566H8.97266Z",
    fill: "#333333"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask24_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 20,
    width: 8,
    height: 4
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0254 20.7256H17.7898V23.3358H10.0254V20.7256Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask25_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 20,
    width: 8,
    height: 4
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M17.756 21.8663C17.6695 22.3483 17.2085 22.6692 16.7264 22.5823C16.4913 22.543 14.6932 22.4142 12.3596 22.7875C11.6657 22.8988 10.8707 23.065 10.0352 23.3139C10.1918 22.659 10.3488 22.0037 10.5053 21.3493C11.028 21.2237 11.5649 21.1169 12.1137 21.0301C14.5511 20.6438 16.5777 20.7525 17.0403 20.8361C17.5224 20.923 17.843 21.3842 17.756 21.8663Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask26_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 20,
    width: 8,
    height: 4
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M17.756 21.8668C17.6695 22.3488 17.2085 22.6697 16.7264 22.5828C16.4913 22.5435 14.6932 22.4146 12.3596 22.788C11.6657 22.8993 10.8707 23.0655 10.0352 23.3143C10.1918 22.6595 10.3488 22.0042 10.5053 21.3497C11.028 21.2242 11.5649 21.1174 12.1137 21.0306C14.5511 20.6443 16.5777 20.753 17.0403 20.8366C17.5224 20.9235 17.843 21.3847 17.756 21.8668Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_3780_17935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.0352 20.6431V23.3131H17.843V20.6431H10.0352Z",
    fill: "#333333"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask27_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 16,
    width: 8,
    height: 3
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0488 16.3311H18.9454V18.9412H11.0488V16.3311Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask27_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask28_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 16,
    width: 8,
    height: 3
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M18.913 17.4536C18.8261 17.9352 18.3652 18.2557 17.8832 18.1695C17.6479 18.1299 15.8499 18.0009 13.5166 18.375C12.7904 18.491 11.9531 18.6678 11.0742 18.936C11.2292 18.2796 11.3842 17.6224 11.5414 16.9655C12.1022 16.8274 12.6794 16.7108 13.2707 16.617C15.7081 16.2307 17.7348 16.3394 18.1971 16.423C18.6794 16.5099 19 16.9711 18.913 17.4536Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask28_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask29_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 16,
    width: 8,
    height: 3
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M18.913 17.4546C18.8261 17.9362 18.3652 18.2567 17.8832 18.1705C17.6479 18.1309 15.8499 18.0019 13.5166 18.3759C12.7904 18.492 11.9531 18.6688 11.0742 18.937C11.2292 18.2806 11.3842 17.6234 11.5414 16.9664C12.1022 16.8283 12.6794 16.7118 13.2707 16.618C15.7081 16.2317 17.7348 16.3404 18.1971 16.424C18.6794 16.5109 19 16.9721 18.913 17.4546Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask29_3780_17935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0742 16.2305V18.9358H19V16.2305H11.0742Z",
    fill: "#333333"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask30_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 11,
    width: 9,
    height: 4
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1055 11.9023H20.1012V14.5786H12.1055V11.9023Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask30_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask31_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 11,
    width: 9,
    height: 4
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0717 13.0444C19.9849 13.5265 19.5238 13.8471 19.0422 13.7605C18.8069 13.7211 17.0089 13.5919 14.6752 13.9659C13.921 14.0866 13.0471 14.2726 12.1309 14.5587C12.298 13.8939 12.4698 13.2308 12.6483 12.5693C13.2252 12.4253 13.8199 12.3046 14.4295 12.2078C16.8668 11.8219 18.8935 11.931 19.3557 12.014C19.8381 12.1008 20.1586 12.5624 20.0717 13.0444Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask31_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask32_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 11,
    width: 9,
    height: 4
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0717 13.0454C19.9849 13.5275 19.5238 13.848 19.0422 13.7614C18.8069 13.7221 17.0089 13.5929 14.6752 13.9669C13.921 14.0876 13.0471 14.2736 12.1309 14.5597C12.298 13.8949 12.4698 13.2318 12.6483 12.5703C13.2252 12.4263 13.8199 12.3056 14.4295 12.2088C16.8668 11.8229 18.8935 11.932 19.3557 12.015C19.8381 12.1018 20.1586 12.5634 20.0717 13.0454Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask32_3780_17935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.1328 11.8213V14.5581H20.1605V11.8213H12.1328Z",
    fill: "#333333"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask33_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 8,
    width: 9,
    height: 3
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0977 8.26855H21.0603V10.9118H13.0977V8.26855Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask33_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask34_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 8,
    width: 9,
    height: 3
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0284 9.39716C20.9414 9.87922 20.4805 10.1993 19.9984 10.1131C19.7633 10.0735 17.9652 9.94465 15.6319 10.3183C14.8855 10.4379 14.0222 10.6209 13.1172 10.9022C13.2292 10.5155 13.3438 10.13 13.4618 9.74576C13.553 9.44905 13.6511 9.16227 13.7562 8.88504C14.2859 8.75714 14.8297 8.64873 15.3861 8.56084C17.8235 8.17468 19.8501 8.28335 20.3127 8.36634C20.7948 8.45346 21.1152 8.91473 21.0284 9.39716Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask34_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask35_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 8,
    width: 9,
    height: 3
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0284 9.39521C20.9414 9.87726 20.4805 10.1973 19.9984 10.1111C19.7633 10.0715 17.9652 9.9427 15.6319 10.3163C14.8855 10.436 14.0222 10.619 13.1172 10.9002C13.2292 10.5135 13.3438 10.128 13.4618 9.74381C13.553 9.4471 13.6511 9.16032 13.7562 8.88309C14.2859 8.75519 14.8297 8.64678 15.3861 8.55888C17.8235 8.17273 19.8501 8.2814 20.3127 8.36439C20.7948 8.4515 21.1152 8.91277 21.0284 9.39521Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask35_3780_17935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1172 8.17334V10.9008H21.1152V8.17334H13.1172Z",
    fill: "#333333"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask36_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 13,
    width: 21,
    height: 7
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4238 13.0264H41.0166V19.5353H21.4238V13.0264Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask36_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask37_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 13,
    width: 20,
    height: 7
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1123 19.5317C39.8705 19.5317 39.6296 19.4335 39.4545 19.2399C35.0614 14.3887 22.4977 14.8244 22.3711 14.8294C21.8807 14.8489 21.469 14.4673 21.4499 13.9776C21.4304 13.4883 21.8117 13.0756 22.3014 13.0565C22.4378 13.0508 25.6869 12.9313 29.5728 13.4589C31.8728 13.7715 33.9156 14.2483 35.6453 14.876C37.8702 15.6835 39.5945 16.7511 40.7698 18.0488C41.0985 18.4122 41.0707 18.9733 40.7077 19.302C40.5378 19.456 40.3248 19.5317 40.1123 19.5317Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask37_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask38_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 13,
    width: 20,
    height: 7
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1104 19.5307C39.8685 19.5307 39.6277 19.4325 39.4525 19.2389C35.0595 14.3877 22.4957 14.8234 22.3691 14.8285C21.8788 14.848 21.4671 14.4663 21.448 13.9767C21.4285 13.4874 21.8097 13.0746 22.2994 13.0555C22.4358 13.0498 25.685 12.9303 29.5708 13.4579C31.8709 13.7705 33.9137 14.2473 35.6434 14.8751C37.8683 15.6825 39.5926 16.7501 40.7678 18.0478C41.0965 18.4113 41.0688 18.9723 40.7057 19.301C40.5359 19.455 40.3228 19.5307 40.1104 19.5307Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask38_3780_17935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4277 12.9297V19.5301H41.0958V12.9297H21.4277Z",
    fill: "#333333"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask39_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 17,
    width: 21,
    height: 7
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5977 17.2568H40.1905V23.7657H20.5977V17.2568Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask39_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask40_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 17,
    width: 21,
    height: 7
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2826 23.7503C39.0407 23.7503 38.7995 23.6521 38.6245 23.4589C34.2367 18.6132 21.6676 19.0434 21.5411 19.0483C21.051 19.0675 20.6391 18.6859 20.6198 18.1962C20.6007 17.7069 20.982 17.2946 21.4716 17.2751C21.6081 17.2698 24.857 17.1499 28.7428 17.6779C31.0427 17.9901 33.0859 18.4668 34.8152 19.0946C37.0405 19.902 38.7645 20.9699 39.9398 22.2677C40.2689 22.6309 40.2411 23.1918 39.8777 23.5209C39.7079 23.6747 39.4948 23.7503 39.2826 23.7503Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask40_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask41_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 20,
    y: 17,
    width: 21,
    height: 7
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2826 23.7498C39.0407 23.7498 38.7995 23.6516 38.6245 23.4584C34.2367 18.6127 21.6676 19.0429 21.5411 19.0478C21.051 19.067 20.6391 18.6854 20.6198 18.1957C20.6007 17.7064 20.982 17.2941 21.4716 17.2746C21.6081 17.2693 24.857 17.1494 28.7428 17.6774C31.0427 17.9896 33.0859 18.4663 34.8152 19.0941C37.0405 19.9015 38.7645 20.9694 39.9398 22.2673C40.2689 22.6304 40.2411 23.1913 39.8777 23.5205C39.7079 23.6742 39.4948 23.7498 39.2826 23.7498Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask41_3780_17935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6016 17.1499V23.7503H40.2697V17.1499H20.6016Z",
    fill: "#333333"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask42_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 21,
    width: 21,
    height: 7
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M19.541 21.1553H39.1338V27.6642H19.541V21.1553Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask42_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask43_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 21,
    width: 21,
    height: 7
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2197 27.6468C37.9779 27.6468 37.737 27.5487 37.5619 27.355C33.1741 22.5097 20.6049 22.9396 20.4785 22.9445C19.9884 22.9636 19.5764 22.5824 19.5573 22.0927C19.5381 21.603 19.9194 21.1907 20.4088 21.1716C20.5452 21.1663 23.7943 21.0464 27.6802 21.574C29.9801 21.8866 32.023 22.3633 33.7523 22.9911C35.9776 23.7986 37.7019 24.8661 38.8772 26.164C39.2059 26.5274 39.1781 27.0883 38.8151 27.4172C38.6452 27.5712 38.4322 27.6468 38.2197 27.6468Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask43_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask44_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 21,
    width: 21,
    height: 7
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2217 27.6497C37.9798 27.6497 37.739 27.5516 37.5638 27.3579C33.1761 22.5126 20.6069 22.9425 20.4804 22.9474C19.9904 22.9665 19.5784 22.5853 19.5593 22.0956C19.5401 21.606 19.9213 21.1936 20.4107 21.1745C20.5471 21.1692 23.7963 21.0493 27.6821 21.5769C29.982 21.8895 32.025 22.3663 33.7543 22.994C35.9796 23.8016 37.7039 24.8691 38.8791 26.1669C39.2078 26.5304 39.1801 27.0913 38.817 27.4201C38.6472 27.5741 38.4341 27.6497 38.2217 27.6497Z",
    fill: "white"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask44_3780_17935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5391 21.0479V27.6483H39.2068V21.0479H19.5391Z",
    fill: "#333333"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask45_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 25,
    width: 20,
    height: 7
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0781 25.417H38.6379V31.9589H19.0781V25.417Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask45_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask46_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 25,
    width: 20,
    height: 7
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7454 31.9235C37.5035 31.9235 37.2624 31.8251 37.0873 31.6317C32.6995 26.786 20.1305 27.2162 20.0039 27.2212C19.5139 27.2403 19.1018 26.8588 19.0827 26.3692C19.0635 25.8798 19.4449 25.4674 19.9344 25.4479C20.071 25.4426 23.3197 25.3227 27.2056 25.8507C29.5056 26.1629 31.5488 26.6397 33.2781 27.2675C35.5033 28.0753 37.2273 29.1429 38.4026 30.4407C38.7317 30.8038 38.7039 31.3648 38.3405 31.6939C38.1706 31.8475 37.9575 31.9235 37.7454 31.9235Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask46_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask47_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 25,
    width: 20,
    height: 7
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7454 31.9226C37.5035 31.9226 37.2624 31.8241 37.0873 31.6307C32.6995 26.7851 20.1305 27.2152 20.0039 27.2203C19.5139 27.2394 19.1018 26.8579 19.0827 26.3682C19.0635 25.8788 19.4449 25.4664 19.9344 25.4469C20.071 25.4417 23.3197 25.3218 27.2056 25.8497C29.5056 26.162 31.5488 26.6387 33.2781 27.2665C35.5033 28.0743 37.2273 29.1419 38.4026 30.4397C38.7317 30.8028 38.7039 31.3638 38.3405 31.6929C38.1706 31.8465 37.9575 31.9226 37.7454 31.9226Z",
    fill: "white"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask47_3780_17935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.0645 25.3242V31.925H38.7326V25.3242H19.0645Z",
    fill: "#333333"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask48_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 29,
    width: 21,
    height: 8
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9863 29.8438H37.5791V36.3527H17.9863V29.8438Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask48_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask49_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 29,
    width: 20,
    height: 8
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M36.681 36.3475C36.4392 36.3475 36.1982 36.2494 36.0228 36.0558C31.635 31.2104 19.066 31.6403 18.9394 31.6452C18.4501 31.6651 18.0373 31.283 18.0182 30.7935C17.9994 30.3038 18.3804 29.8915 18.8701 29.8723C19.0065 29.867 22.2556 29.7471 26.1412 30.2747C28.4411 30.5873 30.4843 31.064 32.2136 31.6918C34.4388 32.4993 36.163 33.5668 37.3381 34.8647C37.6672 35.2281 37.6394 35.7891 37.276 36.1179C37.1061 36.2718 36.8931 36.3475 36.681 36.3475Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask49_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask50_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 29,
    width: 20,
    height: 8
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M36.681 36.347C36.4392 36.347 36.1982 36.2489 36.0228 36.0553C31.635 31.2099 19.066 31.6398 18.9394 31.6447C18.4501 31.6646 18.0373 31.2825 18.0182 30.793C17.9994 30.3033 18.3804 29.891 18.8701 29.8718C19.0065 29.8665 22.2556 29.7466 26.1412 30.2742C28.4411 30.5868 30.4843 31.0635 32.2136 31.6913C34.4388 32.4988 36.163 33.5663 37.3381 34.8642C37.6672 35.2276 37.6394 35.7887 37.276 36.1174C37.1061 36.2714 36.8931 36.347 36.681 36.347Z",
    fill: "white"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask50_3780_17935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.998 29.7471V36.3475H37.6658V29.7471H17.998Z",
    fill: "#333333"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask51_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 34,
    width: 20,
    height: 7
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M17.127 34.2383H36.6867V40.7802H17.127V34.2383Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask51_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask52_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 34,
    width: 20,
    height: 7
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7939 40.7497C35.5521 40.7497 35.3112 40.6512 35.1361 40.4579C30.7483 35.6122 18.1793 36.0424 18.0527 36.0474C17.5628 36.0665 17.1507 35.6849 17.1316 35.1952C17.1123 34.7059 17.4937 34.2936 17.983 34.2741C18.1194 34.2688 21.3686 34.1489 25.2545 34.6769C27.5544 34.9891 29.5972 35.4659 31.3269 36.0936C33.5519 36.9014 35.2761 37.969 36.4514 39.2668C36.7802 39.6299 36.7525 40.191 36.3893 40.52C36.2195 40.6737 36.0064 40.7497 35.7939 40.7497Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask52_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask53_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 17,
    y: 34,
    width: 20,
    height: 7
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7939 40.7477C35.5521 40.7477 35.3112 40.6493 35.1361 40.4559C30.7483 35.6103 18.1793 36.0404 18.0527 36.0455C17.5628 36.0646 17.1507 35.6829 17.1316 35.1933C17.1123 34.704 17.4937 34.2916 17.983 34.2721C18.1194 34.2668 21.3686 34.1469 25.2545 34.6749C27.5544 34.9871 29.5972 35.4639 31.3269 36.0917C33.5519 36.8995 35.2761 37.9671 36.4514 39.2648C36.7802 39.628 36.7525 40.189 36.3893 40.518C36.2195 40.6717 36.0064 40.7477 35.7939 40.7477Z",
    fill: "white"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask53_3780_17935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.1113 34.1445V40.7453H36.7792V34.1445H17.1113Z",
    fill: "#333333"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask54_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 38,
    width: 20,
    height: 8
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2676 38.668H35.8273V45.2099H16.2676V38.668Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask54_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask55_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 38,
    width: 20,
    height: 8
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9385 45.1789C34.6966 45.1789 34.4558 45.0804 34.2806 44.8871C29.8929 40.0414 17.3238 40.4713 17.1972 40.4766C16.7075 40.4948 16.2952 40.1142 16.2761 39.6245C16.2569 39.1351 16.6382 38.7228 17.1275 38.7033C17.2639 38.698 20.5131 38.5781 24.3989 39.1061C26.699 39.4183 28.7418 39.8951 30.4715 40.5228C32.6964 41.3306 34.4207 42.3982 35.5959 43.6961C35.9246 44.0591 35.8969 44.6202 35.5338 44.9493C35.364 45.1029 35.1509 45.1789 34.9385 45.1789Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask55_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask56_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 16,
    y: 38,
    width: 20,
    height: 8
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9385 45.1784C34.6966 45.1784 34.4558 45.0799 34.2806 44.8866C29.8929 40.0409 17.3238 40.4708 17.1972 40.4761C16.7075 40.4943 16.2952 40.1137 16.2761 39.6241C16.2569 39.1346 16.6382 38.7223 17.1275 38.7028C17.2639 38.6975 20.5131 38.5776 24.3989 39.1056C26.699 39.4178 28.7418 39.8946 30.4715 40.5223C32.6964 41.3301 34.4207 42.3977 35.5959 43.6956C35.9246 44.0587 35.8969 44.6197 35.5338 44.9488C35.364 45.1024 35.1509 45.1784 34.9385 45.1784Z",
    fill: "white"
  }))), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask56_3780_17935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.2578 38.5786V45.1794H35.9256V38.5786H16.2578Z",
    fill: "#333333"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask57_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 8,
    width: 20,
    height: 8
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2168 8.63281H41.8096V15.1748H22.2168V8.63281Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask57_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask58_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 8,
    width: 20,
    height: 8
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8916 15.155C40.6497 15.155 40.4088 15.0565 40.2338 14.8632C35.8456 10.0175 23.2766 10.4477 23.1503 10.4527C22.6613 10.4724 22.2483 10.0902 22.2292 9.60049C22.21 9.11121 22.5912 8.69885 23.0806 8.67937C23.2171 8.67407 26.4662 8.55417 30.3521 9.08217C32.652 9.39438 34.6949 9.87113 36.4245 10.4989C38.6494 11.3067 40.3738 12.3743 41.549 13.672C41.8778 14.0352 41.85 14.5963 41.487 14.9252C41.3171 15.079 41.104 15.155 40.8916 15.155Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask58_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask59_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 22,
    y: 8,
    width: 20,
    height: 8
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M40.8896 15.1574C40.6478 15.1574 40.4068 15.0589 40.2318 14.8656C35.8437 10.0199 23.2746 10.4501 23.1484 10.4551C22.6594 10.4749 22.2464 10.0926 22.2273 9.60293C22.208 9.11365 22.5893 8.7013 23.0787 8.68181C23.2151 8.67652 26.4643 8.55662 30.3501 9.08461C32.65 9.39682 34.6929 9.87358 36.4225 10.5013C38.6474 11.3091 40.3718 12.3768 41.5471 13.6745C41.8758 14.0377 41.8481 14.5987 41.485 14.9277C41.3152 15.0814 41.1021 15.1574 40.8896 15.1574Z",
    fill: "white"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask59_3780_17935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.209 8.55664V15.1574H41.8768V8.55664H22.209Z",
    fill: "#333333"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask60_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 16,
    width: 3,
    height: 6
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5371 16.8594H44.9821V21.1216H42.5371V16.8594Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask60_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask61_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 16,
    width: 3,
    height: 6
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9699 18.3611C44.9319 19.1818 44.8596 20.0012 44.7658 20.812C44.7545 20.909 44.7433 21.0062 44.7321 21.1034C43.6665 19.5825 42.7489 18.3003 42.7304 18.2745C42.4453 17.8763 42.5365 17.3219 42.935 17.0368C43.3334 16.7513 43.8875 16.8428 44.173 17.2413C44.2153 17.3004 44.5222 17.7293 44.9699 18.3611Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask61_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask62_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 16,
    width: 3,
    height: 6
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9699 18.3591C44.9319 19.1798 44.8596 19.9993 44.7658 20.81C44.7545 20.9071 44.7433 21.0043 44.7321 21.1015C43.6665 19.5806 42.7489 18.2983 42.7304 18.2725C42.4453 17.8744 42.5365 17.3199 42.935 17.0348C43.3334 16.7493 43.8875 16.8408 44.173 17.2394C44.2153 17.2985 44.5222 17.7274 44.9699 18.3591Z",
    fill: "white"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask62_3780_17935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.4453 16.7495V21.1016H44.9699V16.7495H42.4453Z",
    fill: "#333333"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask63_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 22,
    width: 4,
    height: 5
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9746 22.2773H44.4526V26.4734H41.9746V22.2773Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask63_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask64_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 3,
    height: 5
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M44.426 23.7948C44.3271 24.6813 44.229 25.569 44.1306 26.4568C43.0828 24.9618 42.1878 23.7113 42.17 23.6861C41.8845 23.2877 41.9764 22.7336 42.3745 22.4481C42.7729 22.1629 43.327 22.2546 43.6125 22.653C43.6555 22.7127 43.9694 23.1509 44.426 23.7948Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask64_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask65_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 42,
    y: 22,
    width: 3,
    height: 5
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M44.426 23.7919C44.3271 24.6784 44.229 25.5661 44.1306 26.4539C43.0828 24.9588 42.1878 23.7084 42.17 23.6832C41.8845 23.2848 41.9764 22.7307 42.3745 22.4452C42.7729 22.16 43.327 22.2516 43.6125 22.65C43.6555 22.7098 43.9694 23.148 44.426 23.7919Z",
    fill: "white"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask65_3780_17935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.8848 22.1611V26.4551H44.4263V22.1611H41.8848Z",
    fill: "#333333"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask66_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 27,
    width: 3,
    height: 5
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4121 27.6953H43.8571V31.8253H41.4121V27.6953Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask66_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask67_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 27,
    width: 3,
    height: 5
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8269 29.1581C43.7271 30.0396 43.6254 30.9211 43.5204 31.8023C42.4941 30.3389 41.6272 29.128 41.6093 29.1032C41.3241 28.7048 41.4156 28.1508 41.8138 27.8653C42.2123 27.5798 42.7666 27.6717 43.0519 28.0697C43.0938 28.1279 43.3912 28.5435 43.8269 29.1581Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask67_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask68_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 27,
    width: 3,
    height: 5
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8269 29.1591C43.7271 30.0406 43.6254 30.9221 43.5204 31.8033C42.4941 30.3399 41.6272 29.129 41.6093 29.1042C41.3241 28.7058 41.4156 28.1517 41.8138 27.8663C42.2123 27.5808 42.7666 27.6727 43.0519 28.0707C43.0938 28.1289 43.3912 28.5445 43.8269 29.1591Z",
    fill: "white"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask68_3780_17935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.3242 27.5801V31.8026H43.827V27.5801H41.3242Z",
    fill: "#333333"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask69_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 33,
    width: 4,
    height: 5
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5215 33.082H43.1647V37.4764H40.5215V33.082Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask69_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask70_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 33,
    width: 4,
    height: 5
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1439 34.8609C43.0322 35.7236 42.9156 36.5856 42.7933 37.4466C41.6891 35.8683 40.7181 34.5119 40.6992 34.4856C40.4137 34.0871 40.5056 33.533 40.9041 33.2475C41.3022 32.9622 41.8567 33.0539 42.1418 33.4525C42.19 33.5201 42.5865 34.0733 43.1439 34.8609Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask70_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask71_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 33,
    width: 4,
    height: 5
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1439 34.8634C43.0322 35.726 42.9156 36.588 42.7933 37.449C41.6891 35.8707 40.7181 34.5144 40.6992 34.4881C40.4137 34.0895 40.5056 33.5354 40.9041 33.25C41.3022 32.9646 41.8567 33.0564 42.1418 33.4549C42.19 33.5225 42.5865 34.0757 43.1439 34.8634Z",
    fill: "white"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask71_3780_17935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.4141 32.9644V37.4488H43.1443V32.9644H40.4141Z",
    fill: "#333333"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask72_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 38,
    width: 4,
    height: 5
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M39.793 38.501H42.4031V42.7301H39.793V38.501Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask72_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask73_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 38,
    width: 4,
    height: 5
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3773 40.2223C42.2455 41.0539 42.107 41.8843 41.9606 42.7129C40.9096 41.2129 40.0102 39.9567 39.9921 39.9313C39.707 39.5331 39.7985 38.9787 40.1966 38.6932C40.5954 38.4081 41.1495 38.4996 41.4346 38.898C41.4816 38.9635 41.8509 39.4796 42.3773 40.2223Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask73_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask74_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 39,
    y: 38,
    width: 4,
    height: 5
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3773 40.2233C42.2455 41.0549 42.107 41.8853 41.9606 42.7139C40.9096 41.2139 40.0102 39.9577 39.9921 39.9323C39.707 39.5341 39.7985 38.9797 40.1966 38.6942C40.5954 38.4091 41.1495 38.5006 41.4346 38.899C41.4816 38.9644 41.8509 39.4806 42.3773 40.2233Z",
    fill: "white"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask74_3780_17935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.707 38.4111V42.7159H42.3773V38.4111H39.707Z",
    fill: "#333333"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask75_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 43,
    width: 4,
    height: 6
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7051 43.9512H41.3813V48.2133H38.7051V43.9512Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask75_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask76_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 43,
    width: 4,
    height: 6
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3695 45.8226C41.2092 46.6105 41.0404 47.3967 40.8619 48.1803C40.8616 48.1816 40.8612 48.1829 40.861 48.1843C39.8007 46.6704 38.8891 45.3971 38.8709 45.3715C38.5858 44.9735 38.6773 44.419 39.0758 44.1339C39.4742 43.8485 40.0283 43.94 40.3137 44.3384C40.3637 44.4081 40.7839 44.9953 41.3695 45.8226Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask76_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask77_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 38,
    y: 43,
    width: 4,
    height: 6
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3695 45.8226C41.2092 46.6105 41.0404 47.3967 40.8619 48.1803C40.8616 48.1816 40.8612 48.1829 40.861 48.1843C39.8007 46.6704 38.8891 45.3971 38.8709 45.3715C38.5858 44.9735 38.6773 44.419 39.0758 44.1339C39.4742 43.8485 40.0283 43.94 40.3137 44.3384C40.3637 44.4081 40.7839 44.9953 41.3695 45.8226Z",
    fill: "white"
  }))), _g26 || (_g26 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask77_3780_17935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.5859 43.8486V48.1845H41.3696V43.8486H38.5859Z",
    fill: "#333333"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask78_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 2,
    width: 5,
    height: 6
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9707 2.71777H19.506V7.40947H15.9707V2.71777Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask78_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask79_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 2,
    width: 5,
    height: 6
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5044 2.74023C19.3008 3.10432 19.0748 3.54649 18.8257 4.08275C18.1825 5.46746 17.7232 6.77048 17.7189 6.783C17.5904 7.14851 17.2477 7.37708 16.8817 7.37708C16.7838 7.37708 16.6847 7.36056 16.5879 7.32688C16.1254 7.16438 15.8822 6.65846 16.0444 6.1959C16.0582 6.15602 16.2999 5.4694 16.6828 4.54983C17.5164 3.81404 18.4626 3.22074 19.5044 2.74023Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask79_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask80_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 15,
    y: 2,
    width: 5,
    height: 6
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5044 2.74023C19.3008 3.10432 19.0748 3.54649 18.8257 4.08275C18.1825 5.46746 17.7232 6.77048 17.7189 6.783C17.5904 7.14851 17.2477 7.37708 16.8817 7.37708C16.7838 7.37708 16.6847 7.36056 16.5879 7.32688C16.1254 7.16438 15.8822 6.65846 16.0444 6.1959C16.0582 6.15602 16.2999 5.4694 16.6828 4.54983C17.5164 3.81404 18.4626 3.22074 19.5044 2.74023Z",
    fill: "white"
  }))), _g27 || (_g27 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask80_3780_17935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8809 2.74023V7.37708H19.503V2.74023H15.8809Z",
    fill: "#333333"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask81_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 1,
    width: 5,
    height: 7
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M19.541 1.42969H23.638V7.40995H19.541V1.42969Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask81_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask82_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 1,
    width: 5,
    height: 7
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2905 2.0563C20.7106 3.26523 20.2612 4.49494 19.9738 5.28197C19.8648 5.57998 19.7419 5.91606 19.6923 6.02305C19.4479 6.41192 19.5404 6.92972 19.916 7.20759C20.075 7.32517 20.2597 7.3817 20.4433 7.3817C20.7149 7.3817 20.9832 7.25741 21.1573 7.02226C21.2895 6.8435 21.3725 6.62435 21.6404 5.89128C21.9691 4.99093 22.5196 3.48464 23.217 2.17659C23.3598 1.90891 23.4979 1.67001 23.6304 1.45654C22.8163 1.62045 22.0349 1.81766 21.2905 2.0563Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask82_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask83_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 19,
    y: 1,
    width: 5,
    height: 7
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2905 2.05923C20.7106 3.26816 20.2612 4.49787 19.9738 5.2849C19.8648 5.58291 19.7419 5.91899 19.6923 6.02598C19.4479 6.41485 19.5404 6.93265 19.916 7.21052C20.075 7.3281 20.2597 7.38463 20.4433 7.38463C20.7149 7.38463 20.9832 7.26034 21.1573 7.02519C21.2895 6.84643 21.3725 6.62728 21.6404 5.89421C21.9691 4.99386 22.5196 3.48757 23.217 2.17952C23.3598 1.91184 23.4979 1.67294 23.6304 1.45947C22.8163 1.62338 22.0349 1.82059 21.2905 2.05923Z",
    fill: "white"
  }))), _g28 || (_g28 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask83_3780_17935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.4492 1.45947V7.38463H23.6318V1.45947H19.4492Z",
    fill: "#333333"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask84_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 1,
    width: 5,
    height: 7
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1094 1H27.4707V7.04634H23.1094V1Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask84_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask85_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 1,
    width: 5,
    height: 7
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0653 1.20242C24.9662 1.36633 24.8684 1.53876 24.773 1.71919C24.0589 3.06351 23.6016 4.54412 23.3559 5.33941C23.3053 5.50254 23.2485 5.68633 23.2233 5.75499C23.0192 6.16541 23.1623 6.67018 23.5617 6.91049C23.7047 6.99606 23.8621 7.03659 24.0169 7.03659C24.3187 7.03659 24.6127 6.883 24.7789 6.60616C24.8671 6.45916 24.9173 6.29654 25.0511 5.86302C25.2798 5.124 25.7054 3.7478 26.3401 2.55139C26.6216 2.02146 27.0009 1.42247 27.4472 1.00586C26.6473 1.02432 25.8507 1.09014 25.0653 1.20242Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask85_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask86_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 23,
    y: 1,
    width: 5,
    height: 7
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0653 1.20486C24.9662 1.36877 24.8684 1.5412 24.773 1.72163C24.0589 3.06595 23.6016 4.54656 23.3559 5.34185C23.3053 5.50498 23.2485 5.68877 23.2233 5.75743C23.0192 6.16785 23.1623 6.67262 23.5617 6.91293C23.7047 6.9985 23.8621 7.03903 24.0169 7.03903C24.3187 7.03903 24.6127 6.88544 24.7789 6.6086C24.8671 6.4616 24.9173 6.29898 25.0511 5.86546C25.2798 5.12644 25.7054 3.75024 26.3401 2.55383C26.6216 2.0239 27.0009 1.42492 27.4472 1.0083C26.6473 1.02676 25.8507 1.09258 25.0653 1.20486Z",
    fill: "white"
  }))), _g29 || (_g29 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask86_3780_17935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.0195 1.0083V7.03903H27.4476V1.0083H23.0195Z",
    fill: "#333333"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask87_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 1,
    width: 5,
    height: 7
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4043 1.03223H31.2039V7.04553H27.4043V1.03223Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask87_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask88_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 1,
    width: 5,
    height: 7
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2012 1.26218C30.82 1.72978 30.4456 2.39975 30.1026 3.24137C29.4838 4.76121 29.1835 6.30119 29.1805 6.31668C29.0988 6.74091 28.7268 7.03659 28.3098 7.03659C28.2547 7.03659 28.1984 7.03104 28.142 7.02046C27.6609 6.92792 27.3457 6.46368 27.4379 5.98266C27.4508 5.91362 27.7687 4.27645 28.4493 2.5967C28.6862 2.0123 28.9382 1.49282 29.2059 1.03955C29.8739 1.08111 30.5404 1.15519 31.2012 1.26218Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask88_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask89_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 27,
    y: 1,
    width: 5,
    height: 7
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2012 1.26316C30.82 1.73076 30.4456 2.40072 30.1026 3.24234C29.4838 4.76219 29.1835 6.30217 29.1805 6.31766C29.0988 6.74189 28.7268 7.03757 28.3098 7.03757C28.2547 7.03757 28.1984 7.03202 28.142 7.02144C27.6609 6.9289 27.3457 6.46466 27.4379 5.98364C27.4508 5.91459 27.7687 4.27743 28.4493 2.59767C28.6862 2.01328 28.9382 1.4938 29.2059 1.04053C29.8739 1.08209 30.5404 1.15617 31.2012 1.26316Z",
    fill: "white"
  }))), _g30 || (_g30 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask89_3780_17935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3457 1.04053V7.03757H31.2012V1.04053H27.3457Z",
    fill: "#333333"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask90_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 1,
    width: 5,
    height: 7
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7637 1.82422H35.5302V7.04456H31.7637V1.82422Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask90_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask91_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 1,
    width: 5,
    height: 7
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7289 1.84082C33.5878 2.02319 33.4514 2.21949 33.3199 2.42986C32.6564 3.4905 32.254 4.69182 32.0377 5.3374C31.9979 5.45471 31.951 5.59552 31.9227 5.67115C31.7393 5.95858 31.731 6.33892 31.9322 6.64093C32.1033 6.89725 32.3848 7.03599 32.6714 7.03599C32.8402 7.03599 33.0113 6.98747 33.1626 6.88667C33.4544 6.69204 33.5376 6.44424 33.7197 5.9014C33.9803 5.12367 34.5576 3.40261 35.5309 2.48381C34.9438 2.23898 34.3412 2.02486 33.7289 1.84082Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask91_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask92_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 31,
    y: 1,
    width: 5,
    height: 7
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7308 1.83887C33.5898 2.02123 33.4534 2.21754 33.3218 2.42791C32.6583 3.48855 32.2559 4.68987 32.0396 5.33544C31.9999 5.45276 31.953 5.59357 31.9246 5.6692C31.7412 5.95662 31.733 6.33697 31.9342 6.63898C32.1053 6.8953 32.3868 7.03404 32.6733 7.03404C32.8421 7.03404 33.0133 6.98551 33.1645 6.88471C33.4563 6.69009 33.5396 6.44229 33.7217 5.89945C33.9823 5.12171 34.5596 3.40066 35.5328 2.48186C34.9457 2.23703 34.3431 2.02291 33.7308 1.83887Z",
    fill: "white"
  }))), _g31 || (_g31 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask92_3780_17935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.7324 1.83887V7.03404H35.5323V1.83887H31.7324Z",
    fill: "#333333"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask93_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 43,
    width: 4,
    height: 12
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M5.29883 43.3906H8.04116V54.2608H5.29883V43.3906Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask93_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask94_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 43,
    width: 4,
    height: 12
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M8.01691 54.2488C7.75491 53.968 7.50207 53.6769 7.25853 53.3749C6.41536 52.3289 5.85071 51.2379 5.49721 50.1145C5.49553 50.0974 5.4936 50.0801 5.4923 50.0629C5.21004 46.9978 5.34298 44.3559 5.34892 44.2449C5.37434 43.7556 5.7916 43.3792 6.28088 43.4051C6.7699 43.4307 7.14625 43.8481 7.12082 44.3374C7.12018 44.3499 7.08804 44.9874 7.08804 45.9805C7.08804 47.0103 7.1225 48.4238 7.26086 49.9208C7.41625 51.599 7.67063 53.0545 8.01691 54.2488Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask94_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask95_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 43,
    width: 4,
    height: 12
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M8.01495 54.2454C7.75296 53.9645 7.50012 53.6735 7.25658 53.3715C6.41341 52.3254 5.84876 51.2345 5.49526 50.1111C5.49358 50.0939 5.49164 50.0767 5.49035 50.0595C5.20809 46.9944 5.34103 44.3525 5.34696 44.2415C5.37239 43.7522 5.78965 43.3758 6.27893 43.4016C6.76795 43.4273 7.14429 43.8447 7.11887 44.334C7.11822 44.3465 7.08609 44.984 7.08609 45.9771C7.08609 47.0069 7.12055 48.4204 7.2589 49.9174C7.41429 51.5956 7.66868 53.051 8.01495 54.2454Z",
    fill: "white"
  }))), _g32 || (_g32 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask95_3780_17935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.20898 43.3779V54.2475H8.01585V43.3779H5.20898Z",
    fill: "#333333"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask96_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 43,
    width: 5,
    height: 15
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30664 43.292H12.1723V57.4992H8.30664V43.292Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask96_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask97_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 43,
    width: 5,
    height: 15
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1529 57.4772C11.2594 56.9693 10.4092 56.3918 9.61497 55.7409C9.57005 55.7039 9.52475 55.6672 9.48022 55.6295C9.02889 54.2124 8.70533 52.644 8.51574 50.9491C8.10015 47.2324 8.46747 44.2112 8.48308 44.0843C8.54387 43.5983 8.9872 43.2528 9.47351 43.3142C9.95956 43.3746 10.3045 43.8177 10.2438 44.304C10.2414 44.3226 10.0947 45.5391 10.0947 47.3365C10.0947 48.3416 10.141 49.5283 10.2834 50.7891C10.5123 52.8092 11.0268 55.2928 12.1529 57.4772Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask97_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask98_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 43,
    width: 5,
    height: 15
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1529 57.4787C11.2594 56.9708 10.4092 56.3932 9.61497 55.7424C9.57005 55.7053 9.52475 55.6687 9.48022 55.631C9.02889 54.2139 8.70533 52.6455 8.51574 50.9505C8.10015 47.2339 8.46747 44.2127 8.48308 44.0858C8.54387 43.5997 8.9872 43.2542 9.47351 43.3157C9.95956 43.3761 10.3045 43.8191 10.2438 44.3055C10.2414 44.324 10.0947 45.5406 10.0947 47.3379C10.0947 48.3431 10.141 49.5298 10.2834 50.7906C10.5123 52.8107 11.0268 55.2943 12.1529 57.4787Z",
    fill: "white"
  }))), _g33 || (_g33 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask98_3780_17935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.09961 43.2559V57.4803H12.1523V43.2559H8.09961Z",
    fill: "#333333"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask99_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 43,
    width: 5,
    height: 16
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6113 43.2578H15.6753V58.7536H11.6113V43.2578Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask99_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask100_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 43,
    width: 5,
    height: 16
  }, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5765 57.451C14.1149 54.4945 13.6193 51.2688 13.4613 49.0832C13.2881 46.6871 13.4677 44.8792 13.5439 44.4999C13.6704 44.1841 13.6081 43.8097 13.3552 43.5506C13.013 43.1997 12.4513 43.1925 12.1004 43.5351C11.8668 43.7631 11.814 44.0367 11.7598 44.4283C11.7208 44.7074 11.6867 45.0612 11.6619 45.4515C11.616 46.175 11.5791 47.3456 11.6653 48.8127C11.8104 51.2636 12.3304 54.8887 13.9857 58.2373C14.0315 58.3301 14.0914 58.4115 14.1618 58.4799C14.324 58.6381 14.5421 58.7277 14.7667 58.7315H14.7819C14.9141 58.7315 15.0483 58.7022 15.1744 58.6398C15.6136 58.4223 15.7939 57.89 15.5765 57.451Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask100_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask101_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 11,
    y: 43,
    width: 5,
    height: 16
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5765 57.45C14.1149 54.4935 13.6193 51.2679 13.4613 49.0822C13.2881 46.6861 13.4677 44.8782 13.5439 44.4989C13.6704 44.1831 13.6081 43.8087 13.3552 43.5496C13.013 43.1987 12.4513 43.1915 12.1004 43.5342C11.8668 43.7621 11.814 44.0357 11.7598 44.4273C11.7208 44.7064 11.6867 45.0602 11.6619 45.4505C11.616 46.174 11.5791 47.3446 11.6653 48.8117C11.8104 51.2626 12.3304 54.8877 13.9857 58.2364C14.0315 58.3292 14.0914 58.4105 14.1618 58.4789C14.324 58.6371 14.5421 58.7267 14.7667 58.7306H14.7819C14.9141 58.7306 15.0483 58.7013 15.1744 58.6388C15.6136 58.4213 15.7939 57.8891 15.5765 57.45Z",
    fill: "white"
  }))), _g34 || (_g34 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask101_3780_17935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5801 43.1924V58.7314H15.7949V43.1924H11.5801Z",
    fill: "#333333"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask102_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 43,
    width: 6,
    height: 16
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9492 43.3242H19.1123V58.9852H14.9492V43.3242Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask102_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask103_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 43,
    width: 6,
    height: 16
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M19.003 57.6759C17.4923 54.7032 16.9769 51.4356 16.8107 49.2176C16.6286 46.7855 16.8101 44.9451 16.888 44.5599C17.0142 44.2441 16.9518 43.8697 16.6991 43.6106C16.3568 43.2598 15.7951 43.2525 15.4444 43.5951C15.2099 43.8238 15.1568 44.1 15.1026 44.4955C15.0629 44.7799 15.0292 45.1395 15.0047 45.5352C14.9585 46.2718 14.9221 47.4619 15.0136 48.9493C15.167 51.4379 15.7095 55.1116 17.4209 58.4795C17.5776 58.7877 17.8894 58.9651 18.2126 58.9651C18.3477 58.9651 18.4852 58.934 18.6141 58.8683C19.0505 58.6466 19.225 58.1123 19.003 57.6759Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask103_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask104_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 14,
    y: 43,
    width: 6,
    height: 16
  }, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0049 57.674C17.4942 54.7013 16.9789 51.4336 16.8127 49.2157C16.6305 46.7835 16.812 44.9432 16.89 44.5579C17.0162 44.2421 16.9537 43.8677 16.701 43.6087C16.3587 43.2579 15.7971 43.2505 15.4464 43.5932C15.2119 43.8219 15.1587 44.0981 15.1045 44.4935C15.0649 44.778 15.0312 45.1376 15.0067 45.5333C14.9605 46.2698 14.9241 47.4599 15.0156 48.9474C15.1689 51.436 15.7115 55.1096 17.4229 58.4775C17.5795 58.7857 17.8914 58.9632 18.2145 58.9632C18.3497 58.9632 18.4871 58.9321 18.616 58.8664C19.0524 58.6446 19.2269 58.1103 19.0049 57.674Z",
    fill: "white"
  }))), _g35 || (_g35 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask104_3780_17935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9238 43.25V58.9626H19.2267V43.25H14.9238Z",
    fill: "#333333"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask105_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 43,
    width: 5,
    height: 16
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2852 43.5889H22.3161V58.9856H18.2852V43.5889Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask105_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask106_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 43,
    width: 5,
    height: 16
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2189 57.6918C20.7827 54.744 20.2981 51.5411 20.1443 49.3729C19.9755 46.9957 20.1539 45.205 20.2297 44.829C20.3559 44.5131 20.2937 44.1384 20.0406 43.8797C19.6987 43.5288 19.137 43.5216 18.7865 43.8641C18.5535 44.0909 18.4983 44.3756 18.4457 44.753C18.4068 45.0302 18.3735 45.3807 18.3487 45.7673C18.3024 46.4842 18.2647 47.645 18.3487 49.1007C18.4891 51.5318 18.9975 55.1306 20.6234 58.4689C20.7771 58.7845 21.0933 58.9679 21.4221 58.9679C21.5526 58.9679 21.6847 58.9391 21.8099 58.8783C22.2504 58.6635 22.4334 58.1326 22.2189 57.6918Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask106_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask107_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 18,
    y: 43,
    width: 5,
    height: 16
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M22.2189 57.6938C20.7827 54.746 20.2981 51.543 20.1443 49.3749C19.9755 46.9977 20.1539 45.2069 20.2297 44.831C20.3559 44.515 20.2937 44.1403 20.0406 43.8817C19.6987 43.5308 19.137 43.5235 18.7865 43.8661C18.5535 44.0928 18.4983 44.3776 18.4457 44.7549C18.4068 45.0322 18.3735 45.3827 18.3487 45.7692C18.3024 46.4862 18.2647 47.647 18.3487 49.1027C18.4891 51.5337 18.9975 55.1325 20.6234 58.4708C20.7771 58.7864 21.0933 58.9698 21.4221 58.9698C21.5526 58.9698 21.6847 58.941 21.8099 58.8802C22.2504 58.6655 22.4334 58.1345 22.2189 57.6938Z",
    fill: "white"
  }))), _g36 || (_g36 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask107_3780_17935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.2637 43.5229V58.9692H22.4324V43.5229H18.2637Z",
    fill: "#333333"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask108_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 43,
    width: 5,
    height: 16
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M21.623 43.7881H25.1914V58.1275H21.623V43.7881Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask108_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask109_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 43,
    width: 5,
    height: 16
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1168 56.8978C23.9482 54.0642 23.5721 51.1164 23.4624 49.1429C23.3402 46.9458 23.5054 45.3791 23.5751 45.0324C23.7013 44.7166 23.6392 44.3422 23.3865 44.0831C23.0441 43.7323 22.4824 43.7254 22.1319 44.0677C21.9033 44.2907 21.8491 44.5593 21.7973 44.9142C21.7612 45.1626 21.7286 45.4801 21.7034 45.8319C21.6579 46.4756 21.6149 47.5223 21.6717 48.8565C21.7662 51.0662 22.1564 54.3728 23.4766 57.5745C23.6178 57.9168 23.9482 58.1237 24.2975 58.1237C24.41 58.1237 24.5244 58.1021 24.6347 58.0562C25.0881 57.8698 25.3038 57.3508 25.1168 56.8978Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask109_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask110_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 43,
    width: 5,
    height: 16
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1168 56.8959C23.9482 54.0623 23.5721 51.1145 23.4624 49.141C23.3402 46.9438 23.5054 45.3771 23.5751 45.0304C23.7013 44.7146 23.6392 44.3402 23.3865 44.0812C23.0441 43.7304 22.4824 43.7234 22.1319 44.0657C21.9033 44.2887 21.8491 44.5573 21.7973 44.9122C21.7612 45.1607 21.7286 45.4782 21.7034 45.83C21.6579 46.4736 21.6149 47.5203 21.6717 48.8546C21.7662 51.0643 22.1564 54.3709 23.4766 57.5725C23.6178 57.9148 23.9482 58.1217 24.2975 58.1217C24.41 58.1217 24.5244 58.1001 24.6347 58.0542C25.0881 57.8678 25.3038 57.3489 25.1168 56.8959Z",
    fill: "white"
  }))), _g37 || (_g37 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask110_3780_17935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6133 43.7246V58.1229H25.3022V43.7246H21.6133Z",
    fill: "#333333"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask111_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 44,
    width: 4,
    height: 14
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0918 44.084H28.2306V57.234H25.0918V44.084Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask111_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask112_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 44,
    width: 4,
    height: 14
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1518 56.0559C26.4515 51.0602 26.8946 46.0176 27.0359 45.3267C27.1626 45.0109 27.1005 44.6365 26.8474 44.3772C26.5054 44.0263 25.9434 44.0193 25.5932 44.3616C25.3695 44.5797 25.314 44.8417 25.2653 45.1622C25.2316 45.3812 25.2007 45.6631 25.1759 45.9776C25.131 46.5422 25.084 47.4674 25.116 48.6674C25.1685 50.6356 25.4464 53.6149 26.4717 56.6275C26.5973 56.9965 26.9419 57.229 27.3112 57.229C27.4061 57.229 27.5025 57.2139 27.5976 57.1812C28.0612 57.0236 28.3094 56.5194 28.1518 56.0559Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask112_3780_17935)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask113_3780_17935",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 25,
    y: 44,
    width: 4,
    height: 14
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1518 56.0519C26.4515 51.0563 26.8946 46.0137 27.0359 45.3228C27.1626 45.007 27.1005 44.6326 26.8474 44.3733C26.5054 44.0224 25.9434 44.0154 25.5932 44.3577C25.3695 44.5758 25.314 44.8378 25.2653 45.1583C25.2316 45.3773 25.2007 45.6591 25.1759 45.9737C25.131 46.5383 25.084 47.4635 25.116 48.6635C25.1685 50.6317 25.4464 53.611 26.4717 56.6236C26.5973 56.9926 26.9419 57.2251 27.3112 57.2251C27.4061 57.2251 27.5025 57.21 27.5976 57.1772C28.0612 57.0197 28.3094 56.5155 28.1518 56.0519Z",
    fill: "white"
  }))), _g38 || (_g38 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask113_3780_17935)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.084 44.0176V57.2273H28.3094V44.0176H25.084Z",
    fill: "#333333"
  }))))), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6523 71.5962C25.6523 71.5962 28.1056 71.8347 28.2077 72.7545C28.3098 73.6744 28.2077 80.3858 28.2077 80.3858C28.2077 80.3858 27.8667 73.7768 27.2874 72.993C26.7086 72.2094 25.6523 71.5962 25.6523 71.5962Z",
    fill: "white"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2988 60.4561C18.2988 60.4561 21.2853 61.6485 25.1041 61.3075C25.1041 61.3075 24.324 63.3857 24.4261 64.2375C24.4261 64.2375 23.847 63.2156 24.2556 61.9891C24.2556 61.9891 18.9196 62.1252 18.2988 60.4561Z",
    fill: "white"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8357 65.2827H20.0982C20.0982 65.2827 18.9056 66.8606 19.3487 69.4841L20.5428 65.9069L21.8357 65.2827Z",
    fill: "white"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5089 76.9131C17.5089 76.9131 17.1006 80.0813 17.6798 80.6945C18.2589 81.3077 20.8873 81.3421 20.8873 81.3421C20.8873 81.3421 17.7809 79.9452 17.5089 76.9131Z",
    fill: "white"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M28.2539 61.3424L30.3889 60.8652L28.2539 65.5675L29.469 61.5125L28.2539 61.3424Z",
    fill: "white"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3573 67.3848C24.3573 67.3848 24.3514 69.3708 25.2772 70.1328L23.4375 69.8941L24.3573 69.4855C24.3573 69.4855 23.8802 68.3842 24.3573 67.3848Z",
    fill: "white"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3864 66.0103C16.3729 65.9416 16.0967 69.2297 18.1748 69.2129C18.1748 69.2129 16.7783 67.9864 16.3864 66.0103Z",
    fill: "white"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4785 59.6663C27.4785 59.6663 35.0051 59.7582 38.1223 53.8813C38.1223 53.8813 34.597 57.6786 27.4785 59.6663Z",
    fill: "white"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8257 48.1855C35.8257 48.1855 35.1897 55.0942 29.332 56.3346C29.332 56.3346 32.7117 53.8344 35.8257 48.1855Z",
    fill: "white"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0781 3.49365C36.0781 3.49365 42.3475 6.59775 42.4149 10.5457C42.4149 10.5457 40.7796 7.241 36.0781 3.49365Z",
    fill: "white"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M6.26759 41.6514C6.57412 41.6514 9.81076 39.9139 14.0352 41.0038C14.0352 41.0038 10.4921 40.5086 7.08533 41.9316L5.96094 43.284L6.26759 41.6514Z",
    fill: "white"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M7.05078 38.6861L7.52754 36.9835C7.52754 36.9835 10.4235 35.7481 13.8643 36.3488L8.01527 37.4351L7.05078 38.6861Z",
    fill: "white"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M8.17578 33.9924L8.55084 32.4186C8.55084 32.4186 12.3643 31.403 15.0907 31.928C15.0907 31.928 12.1622 31.8179 9.16402 32.8849L8.17578 33.9924Z",
    fill: "white"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M9.19727 29.8575L9.70836 27.9206C9.70836 27.9206 12.9054 26.8644 16.0425 27.4775C16.0425 27.4775 12.7065 27.3494 10.4577 28.5719L9.19727 29.8575Z",
    fill: "white"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2188 25.168L10.7639 23.4582C10.7639 23.4582 13.7619 22.5039 16.9645 22.9469C16.9645 22.9469 13.2852 23.0064 11.3091 23.9987L10.2188 25.168Z",
    fill: "white"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2754 20.6964L11.8206 18.9866C11.8206 18.9866 14.8187 18.0327 18.0209 18.4758C18.0209 18.4758 14.3415 18.5353 12.3655 19.5275L11.2754 20.6964Z",
    fill: "white"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3379 16.4949L12.8827 14.7851C12.8827 14.7851 15.8811 13.8312 19.0834 14.274C19.0834 14.274 15.4039 14.3334 13.4278 15.326L12.3379 16.4949Z",
    fill: "white"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2852 12.3497L13.6819 11.1046C13.6819 11.1046 15.8642 10.4105 18.1955 10.7329C18.1955 10.7329 15.5169 10.7762 14.0788 11.4985L13.2852 12.3497Z",
    fill: "white"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1977 42.8936C27.9059 42.8669 27.0324 49.3837 28.7699 53.4209C28.7699 53.4209 28.0033 46.6867 29.6898 45.6334C31.3761 44.5801 34.0335 46.0767 34.0335 46.0767C34.0335 46.0767 32.6336 43.3028 28.1977 42.8936Z",
    fill: "white"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2676 11.1402C24.6386 11.1108 25.0097 11.1002 25.3807 11.0956C25.7521 11.0909 26.1227 11.0956 26.4938 11.1058C27.2353 11.1269 27.9759 11.1762 28.7151 11.2472C29.4542 11.3188 30.1913 11.4143 30.9252 11.5363C31.6593 11.6575 32.3898 11.8046 33.1151 11.9807C33.206 12.0018 33.2961 12.026 33.3867 12.0484C33.4771 12.0713 33.5673 12.0944 33.6579 12.1185L33.9282 12.1918L34.1978 12.2681C34.5566 12.3729 34.9141 12.4843 35.2683 12.6065C35.6224 12.7287 35.9737 12.8609 36.3215 13.0032C36.4948 13.0763 36.6678 13.1493 36.839 13.2279L36.9672 13.2864L37.0948 13.3472C37.1793 13.3885 37.2649 13.4275 37.3488 13.4708C37.4328 13.5138 37.5173 13.5551 37.6006 13.5994L37.8494 13.7345C38.0136 13.8277 38.1781 13.9198 38.3378 14.0219L38.4579 14.0965L38.5763 14.1746C38.6553 14.2271 38.7349 14.2776 38.8112 14.3341C38.9658 14.4428 39.1172 14.5572 39.2651 14.6745L39.4828 14.8568C39.5535 14.9202 39.6243 14.9827 39.6937 15.0468L39.8958 15.2461C39.9616 15.3137 40.0248 15.3848 40.0881 15.4539C40.338 15.737 40.5597 16.0446 40.7285 16.3763C40.2276 15.8262 39.6408 15.3954 39.0173 15.0333C38.9393 14.9877 38.8601 14.9443 38.7821 14.8998L38.7229 14.867L38.6631 14.8357L38.5432 14.7729C38.4639 14.7306 38.3829 14.691 38.3024 14.651L38.1815 14.5908L38.0585 14.5341C37.8956 14.4574 37.7304 14.3843 37.5652 14.3127L37.3157 14.2083L37.0643 14.1078C36.9811 14.0734 36.8959 14.0431 36.8116 14.0107L36.685 13.9628L36.5572 13.9171C36.4719 13.8871 36.388 13.8544 36.3021 13.8256L36.0457 13.7371C35.7028 13.6214 35.3574 13.5128 35.0103 13.408C34.6627 13.3046 34.3135 13.2065 33.9625 13.1123L33.6992 13.0422L33.4349 12.9746C33.347 12.9514 33.2588 12.9293 33.1706 12.9079C33.0821 12.886 32.9942 12.8632 32.9052 12.8424C31.4905 12.4978 30.0575 12.2096 28.617 11.9354C27.1754 11.6619 25.7273 11.412 24.2676 11.1402Z",
    fill: "white"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4941 15.6232C23.8648 15.5939 24.2361 15.5829 24.6072 15.5786C24.9782 15.5736 25.3493 15.5786 25.72 15.5886C26.4617 15.61 27.2025 15.6589 27.9417 15.7299C28.6804 15.8017 29.4175 15.8974 30.1517 16.0194C30.8855 16.1406 31.6163 16.2877 32.3413 16.4635C32.4321 16.4849 32.5224 16.5087 32.6128 16.5315C32.7033 16.554 32.7939 16.5771 32.8841 16.6016L33.1544 16.6749L33.4242 16.7509C33.783 16.856 34.1403 16.967 34.4944 17.0892C34.849 17.2118 35.2002 17.344 35.5477 17.4861C35.7212 17.5591 35.894 17.632 36.0651 17.7108L36.1937 17.7692L36.3209 17.8303C36.4059 17.8716 36.491 17.9105 36.5749 17.9539C36.6592 17.9965 36.7435 18.0382 36.8267 18.0821L37.0756 18.2176C37.2397 18.3104 37.4043 18.4029 37.5639 18.5046L37.6841 18.5796L37.8027 18.6577C37.8814 18.7102 37.9611 18.7604 38.0373 18.8168C38.192 18.9256 38.3434 19.0398 38.4913 19.1576L38.7094 19.3395C38.7797 19.403 38.8508 19.4658 38.9201 19.5299L39.1221 19.7292C39.1882 19.7968 39.2509 19.8675 39.3147 19.937C39.5642 20.2197 39.7859 20.5277 39.9547 20.8594C39.4541 20.3089 38.867 19.8785 38.2435 19.516C38.1655 19.4708 38.0865 19.4272 38.0083 19.3829L37.9495 19.3499L37.8893 19.3188L37.7697 19.256C37.6904 19.2137 37.6091 19.1741 37.5286 19.1337L37.4076 19.0739L37.285 19.0167C37.1218 18.9401 36.957 18.8674 36.7918 18.7954L36.5419 18.6914L36.2905 18.5908C36.2072 18.5562 36.1221 18.5258 36.0378 18.4934L35.9112 18.4455L35.7834 18.4C35.6981 18.3701 35.6142 18.3371 35.5282 18.3087L35.2719 18.2199C34.929 18.1045 34.5836 17.9959 34.2367 17.8911C33.8891 17.7877 33.5396 17.6896 33.1887 17.5951L32.9254 17.5253L32.6611 17.4577C32.5732 17.4344 32.4849 17.4124 32.3968 17.3906C32.3085 17.3691 32.2203 17.3463 32.1318 17.3255C30.7166 16.9809 29.2836 16.6925 27.8432 16.4182C26.4019 16.145 24.9535 15.8951 23.4941 15.6232Z",
    fill: "white"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6465 19.564C23.0172 19.5346 23.3882 19.524 23.7593 19.5194C24.1307 19.5147 24.5014 19.5194 24.8724 19.5293C25.6142 19.5508 26.3546 19.6001 27.0937 19.6708C27.8328 19.7428 28.57 19.8383 29.3037 19.9601C30.0379 20.0815 30.7684 20.2285 31.4936 20.4042C31.5845 20.4257 31.6747 20.4498 31.7652 20.4723C31.8558 20.4951 31.9462 20.5178 32.0365 20.5423L32.3067 20.6156L32.5763 20.6917C32.9351 20.7967 33.2926 20.9081 33.6469 21.0303C34.0011 21.1526 34.3526 21.2847 34.7002 21.4272C34.8733 21.5001 35.0465 21.5729 35.2176 21.6515L35.3458 21.7102L35.4733 21.7712C35.5582 21.8125 35.6435 21.8514 35.7274 21.8947C35.8113 21.9373 35.896 21.9789 35.9792 22.0232L36.2279 22.1583C36.3922 22.2515 36.5568 22.3437 36.7163 22.4454L36.8366 22.5205L36.9548 22.5984C37.0338 22.651 37.1134 22.7014 37.1898 22.758C37.3444 22.8666 37.4957 22.9807 37.6437 23.0983L37.8619 23.2804C37.9322 23.3438 38.0029 23.4066 38.0722 23.4707L38.2745 23.6699C38.3402 23.7377 38.4033 23.8087 38.4668 23.8777C38.7165 24.1609 38.9382 24.4684 39.1071 24.8003C38.6065 24.2501 38.0194 23.8193 37.3959 23.4571C37.318 23.4115 37.239 23.3683 37.1607 23.3236L37.1019 23.291L37.0418 23.2595L36.9218 23.1968C36.8425 23.1544 36.7616 23.1148 36.6809 23.0748L36.56 23.0147L36.4371 22.9575C36.2742 22.8812 36.1093 22.8082 35.9441 22.7362L35.6944 22.6321L35.443 22.5317C35.3597 22.4973 35.2744 22.4669 35.1901 22.4345L35.0636 22.3867L34.9357 22.3411C34.8506 22.311 34.7665 22.2782 34.6807 22.2495L34.4243 22.1609C34.0813 22.0453 33.7361 21.9366 33.3888 21.8319C33.0416 21.7284 32.692 21.6303 32.3412 21.5361L32.0778 21.4662L31.8134 21.3984C31.7256 21.3753 31.6374 21.3531 31.5491 21.3317C31.4606 21.3099 31.3727 21.287 31.2842 21.2663C29.8691 20.9217 28.4361 20.6332 26.9955 20.3589C25.5544 20.0857 24.1059 19.836 22.6465 19.564Z",
    fill: "white"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M21.457 23.4971C21.8281 23.4677 22.1991 23.4571 22.5702 23.4525C22.9413 23.4478 23.3123 23.4525 23.6834 23.4627C24.4247 23.4839 25.1655 23.5332 25.9047 23.6041C26.6437 23.6758 27.3809 23.7713 28.1146 23.8932C28.8485 24.0144 29.5794 24.1616 30.3046 24.3376C30.3954 24.3588 30.4856 24.3829 30.5761 24.4054C30.6667 24.4282 30.7569 24.4513 30.8471 24.4754L31.1177 24.5488L31.3873 24.625C31.7461 24.7298 32.1036 24.8412 32.4578 24.9634C32.812 25.0857 33.1632 25.2178 33.5111 25.3602C33.6842 25.4332 33.8574 25.5063 34.0285 25.5849L34.1567 25.6433L34.2842 25.7045C34.3689 25.7454 34.4545 25.7844 34.5383 25.8278C34.6222 25.8707 34.7069 25.912 34.7901 25.9563L35.0386 26.0914C35.2031 26.1846 35.3677 26.2768 35.5268 26.3789L35.6471 26.4535L35.7657 26.5318C35.8445 26.5841 35.9241 26.6345 36.0004 26.6911C36.1554 26.7997 36.3064 26.9141 36.4547 27.0314L36.6724 27.2138C36.7431 27.2771 36.8139 27.3396 36.8832 27.4038L37.0854 27.603C37.1511 27.6707 37.2139 27.7418 37.2777 27.8111C37.5272 28.094 37.7492 28.4015 37.918 28.7332C37.4171 28.1832 36.8304 27.7524 36.2069 27.3902C36.1289 27.3449 36.0495 27.3013 35.9713 27.257L35.9125 27.224L35.8527 27.1926L35.7327 27.1301C35.6534 27.0875 35.5721 27.0479 35.4916 27.0079L35.3709 26.9478L35.2481 26.891C35.0852 26.8143 34.92 26.7413 34.7548 26.6696L34.5049 26.5655L34.2539 26.4647C34.1706 26.4304 34.0851 26.4 34.0011 26.3676L33.8742 26.3198L33.7467 26.2741C33.6611 26.244 33.5775 26.2113 33.4916 26.1826L33.2352 26.094C32.8923 25.9784 32.5466 25.8697 32.1997 25.7649C31.8522 25.6615 31.5027 25.5634 31.1521 25.4692L30.8884 25.3991L30.6244 25.3315C30.5365 25.3083 30.4483 25.2865 30.3598 25.2648C30.2715 25.243 30.1834 25.2204 30.0948 25.1994C28.68 24.8548 27.2471 24.5666 25.8065 24.2923C24.365 24.0188 22.9165 23.769 21.457 23.4971Z",
    fill: "white"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9238 27.6635C21.2949 27.6341 21.6659 27.6236 22.0369 27.619C22.4083 27.6143 22.779 27.619 23.15 27.6292C23.8918 27.6504 24.6322 27.6995 25.3713 27.7706C26.1105 27.8423 26.8476 27.9378 27.5814 28.0597C28.3155 28.1809 29.046 28.3279 29.7714 28.5041C29.8622 28.5253 29.9523 28.5494 30.0429 28.5719C30.1334 28.5946 30.2236 28.6178 30.3142 28.6418L30.5845 28.7153L30.8541 28.7915C31.2129 28.8966 31.5704 29.0076 31.9245 29.1299C32.2787 29.2522 32.6302 29.3843 32.9778 29.5267C33.151 29.5997 33.3241 29.6728 33.4952 29.7514L33.6235 29.8098L33.751 29.871C33.8359 29.9119 33.9211 29.9509 34.005 29.9943C34.089 30.0371 34.1736 30.0784 34.2568 30.1227L34.5056 30.2578C34.6698 30.351 34.8344 30.4433 34.9939 30.5454L35.1142 30.62L35.2325 30.6983C35.3115 30.7504 35.3911 30.801 35.4674 30.8576C35.622 30.9662 35.7733 31.0806 35.9213 31.1979L36.1391 31.3803C36.2098 31.4436 36.2805 31.5061 36.35 31.5703L36.5521 31.7694C36.6179 31.8372 36.681 31.9083 36.7444 31.9776C36.9942 32.2605 37.2158 32.568 37.3848 32.8997C36.8841 32.3497 36.297 31.9189 35.6735 31.5567C35.5956 31.5111 35.5163 31.4678 35.4384 31.4235L35.3795 31.3905L35.3194 31.3591L35.1995 31.2966C35.1201 31.2541 35.0392 31.2144 34.9587 31.1744L34.8377 31.1143L34.7147 31.0575C34.5519 30.9808 34.3866 30.9078 34.2214 30.836L33.972 30.732L33.7206 30.6312C33.6373 30.5969 33.5521 30.5664 33.4678 30.5341L33.3412 30.4861L33.2135 30.4406C33.1282 30.4105 33.0443 30.3778 32.9583 30.3491L32.702 30.2605C32.3589 30.1449 32.0137 30.0362 31.6665 29.9314C31.319 29.828 30.9697 29.7299 30.6188 29.6357L30.3555 29.5657L30.0912 29.4979C30.0033 29.4748 29.915 29.453 29.8269 29.4312C29.7383 29.4094 29.6504 29.3869 29.5615 29.3657C28.1467 29.0211 26.7137 28.7331 25.2733 28.4588C23.8316 28.1853 22.3835 27.9355 20.9238 27.6635Z",
    fill: "white"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M19.8789 32.1782C20.25 32.1488 20.621 32.1382 20.9921 32.1336C21.3631 32.1291 21.7342 32.1336 22.1052 32.1439C22.8466 32.1651 23.5874 32.2142 24.3265 32.285C25.0656 32.357 25.8028 32.4525 26.5365 32.5743C27.2703 32.6957 28.0012 32.8427 28.7264 33.0184C28.8173 33.0399 28.9075 33.064 28.998 33.0865C29.0886 33.1093 29.1788 33.1324 29.269 33.1565L29.5395 33.2298L29.8091 33.3063C30.1679 33.4109 30.5254 33.5223 30.8797 33.6445C31.2339 33.7667 31.5851 33.8989 31.933 34.0414C32.1061 34.1144 32.2793 34.1874 32.4504 34.2657L32.5786 34.3246L32.7061 34.3853C32.7908 34.4266 32.8763 34.4656 32.9602 34.5089C33.0441 34.5515 33.1288 34.5931 33.212 34.6374L33.4605 34.7725C33.625 34.8657 33.7896 34.9579 33.9487 35.06L34.069 35.1347L34.1876 35.2126C34.2663 35.2652 34.346 35.3158 34.4222 35.3722C34.5772 35.481 34.7283 35.5949 34.8765 35.7125L35.0943 35.8946C35.1646 35.9584 35.2357 36.0208 35.305 36.0848L35.5073 36.2841C35.573 36.3519 35.6358 36.4229 35.6996 36.4919C35.9491 36.7751 36.171 37.0828 36.3399 37.4145C35.839 36.8643 35.2522 36.4334 34.6284 36.0713C34.5508 36.0257 34.4714 35.9825 34.3932 35.9378L34.3344 35.9052L34.2746 35.8738L34.1546 35.811C34.0753 35.7686 33.994 35.729 33.9135 35.6891L33.7928 35.629L33.6699 35.5721C33.5071 35.4954 33.3419 35.4225 33.1767 35.3505L32.9268 35.2463L32.6758 35.1459C32.5925 35.1116 32.5069 35.0811 32.4229 35.0487L32.2961 35.0008L32.1685 34.9553C32.083 34.9252 31.9993 34.8924 31.9135 34.8638L31.6571 34.7752C31.3141 34.6596 30.9685 34.5508 30.6216 34.4461C30.274 34.3428 29.9245 34.2445 29.574 34.1505L29.3103 34.0804L29.0463 34.0126C28.9584 33.9895 28.8702 33.9673 28.7817 33.9459C28.6934 33.9241 28.6052 33.9012 28.5167 33.8805C27.1019 33.5359 25.6689 33.2478 24.2283 32.9731C22.7868 32.6999 21.3384 32.4502 19.8789 32.1782Z",
    fill: "white"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8652 36.6149C19.236 36.5855 19.6073 36.5749 19.9784 36.5703C20.3495 36.5654 20.7205 36.5703 21.0912 36.5802C21.8329 36.6016 22.5737 36.6506 23.3127 36.7215C24.0516 36.7933 24.789 36.8891 25.5228 37.011C26.2567 37.1322 26.9876 37.2794 27.7128 37.4551C27.8032 37.4766 27.8935 37.5003 27.9841 37.5232C28.0745 37.546 28.1651 37.5687 28.2552 37.5932L28.5256 37.6665L28.7955 37.7426C29.1543 37.8476 29.5118 37.9586 29.8659 38.0808C30.2202 38.2034 30.5714 38.3356 30.9189 38.478C31.0924 38.551 31.2656 38.6237 31.4364 38.7024L31.5649 38.7609L31.6922 38.8219C31.777 38.8632 31.8627 38.9022 31.9462 38.9456C32.0304 38.9881 32.115 39.0298 32.1982 39.0737L32.4468 39.2092C32.6112 39.302 32.7755 39.3946 32.935 39.4963L33.0553 39.5713L33.1739 39.6493C33.2525 39.7019 33.3322 39.7521 33.4086 39.8085C33.5634 39.9173 33.7145 40.0315 33.8629 40.1492L34.0806 40.3312C34.1509 40.3947 34.2219 40.4574 34.2914 40.5215L34.4932 40.7208C34.5593 40.7884 34.6222 40.8592 34.6859 40.9286C34.9354 41.2114 35.157 41.5193 35.3262 41.851C34.8253 41.3006 34.2382 40.8701 33.6147 40.5076C33.5371 40.4624 33.4577 40.4188 33.3794 40.3745L33.3207 40.3415L33.2605 40.3104L33.1409 40.2477C33.0617 40.2053 32.9803 40.1657 32.8997 40.1255L32.7787 40.0656L32.6563 40.0084C32.4934 39.9317 32.3282 39.8591 32.163 39.787L31.9131 39.683L31.6617 39.5825C31.5785 39.5479 31.4931 39.5174 31.409 39.485L31.2824 39.4372L31.1549 39.3916C31.0693 39.3618 30.9854 39.3287 30.8995 39.3004L30.6434 39.2116C30.3005 39.0962 29.9548 38.9875 29.6079 38.8827C29.2604 38.7793 28.9107 38.6812 28.5599 38.5868L28.2965 38.5169L28.0326 38.4493C27.9447 38.4261 27.8562 38.404 27.7679 38.3822C27.6797 38.3608 27.5914 38.3379 27.5029 38.3171C26.0881 37.9726 24.6549 37.6841 23.2147 37.4098C21.7732 37.1366 20.3247 36.8865 18.8652 36.6149Z",
    fill: "white"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M19.7643 3.3418C19.7418 3.52984 19.7042 3.7073 19.6654 3.88438C19.6252 4.06016 19.5816 4.23324 19.533 4.40411C19.4371 4.74536 19.3288 5.07911 19.2126 5.40887C19.0961 5.73888 18.9766 6.06567 18.8428 6.39143C18.811 6.47338 18.7777 6.55495 18.7424 6.63626L18.7155 6.69743L18.6905 6.75887L18.6382 6.88212C18.602 6.96395 18.5626 7.04591 18.5266 7.12915C18.4893 7.21214 18.4497 7.29538 18.4023 7.37902C18.3842 7.28648 18.373 7.19394 18.3641 7.10114C18.3597 7.05455 18.3555 7.00757 18.3548 6.96176C18.3535 6.91542 18.3538 6.86948 18.3535 6.82327C18.3555 6.73112 18.3542 6.63755 18.3637 6.54669C18.3713 6.45518 18.3809 6.36394 18.3925 6.27282C18.4044 6.18196 18.4215 6.09239 18.4384 6.00256C18.4473 5.95765 18.4556 5.91273 18.4654 5.86808C18.4757 5.82342 18.4866 5.77954 18.4978 5.73527C18.5207 5.64738 18.5431 5.55884 18.5698 5.47185L18.6111 5.34202L18.6545 5.21282C18.7761 4.87094 18.9247 4.53924 19.1054 4.22368C19.196 4.0661 19.2948 3.91238 19.4025 3.76409C19.4303 3.72744 19.457 3.6904 19.4854 3.654C19.5144 3.61799 19.5426 3.58173 19.573 3.54662C19.6324 3.47564 19.6949 3.4062 19.7643 3.3418Z",
    fill: "white"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7293 2.00439C23.7068 2.19244 23.6691 2.37016 23.6308 2.54698C23.5904 2.72302 23.5465 2.89622 23.4983 3.06671C23.4025 3.40834 23.2938 3.74171 23.1774 4.07173C23.0611 4.40148 22.9416 4.72853 22.8078 5.05441C22.776 5.13598 22.7427 5.21755 22.7076 5.29924L22.6809 5.36029L22.6555 5.42172L22.6032 5.54472C22.5669 5.62693 22.5276 5.70889 22.4916 5.79188C22.4543 5.87474 22.4145 5.95837 22.3677 6.04161C22.3492 5.94908 22.338 5.85654 22.3293 5.76374C22.3247 5.71715 22.3204 5.67056 22.3198 5.62435C22.3187 5.57841 22.3191 5.53246 22.3184 5.48587C22.3204 5.39398 22.3191 5.30015 22.3287 5.20929C22.3363 5.11817 22.3458 5.02666 22.3575 4.93542C22.3693 4.84455 22.3868 4.75499 22.4033 4.66516C22.4123 4.62024 22.4206 4.57533 22.4304 4.53067C22.4407 4.48641 22.4516 4.44214 22.4628 4.39813C22.4856 4.30998 22.5081 4.22144 22.5348 4.13484L22.5761 4.005L22.6195 3.87581C22.7413 3.53353 22.8897 3.20184 23.0708 2.88654C23.1609 2.7287 23.2597 2.57537 23.3674 2.42708C23.3953 2.39029 23.422 2.35299 23.4504 2.31699C23.4794 2.28098 23.5075 2.24458 23.5379 2.20922C23.5974 2.13862 23.6598 2.06918 23.7293 2.00439Z",
    fill: "white"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6931 1.76807C27.6452 1.95108 27.5838 2.12196 27.5213 2.2918C27.4576 2.46062 27.3905 2.62646 27.3191 2.7887C27.1778 3.11381 27.0244 3.42937 26.8641 3.74028C26.704 4.05145 26.5407 4.35875 26.3636 4.66308C26.3213 4.74 26.277 4.81641 26.2311 4.89204L26.1961 4.94921L26.1627 5.00639L26.094 5.12125C26.0471 5.19766 25.9968 5.27329 25.95 5.35098C25.9017 5.42791 25.8509 5.50496 25.7927 5.58123C25.7871 5.48702 25.7887 5.39383 25.7927 5.30078C25.7947 5.25419 25.7969 5.20721 25.8026 5.16165C25.8075 5.1157 25.8142 5.07014 25.8202 5.0242C25.8346 4.93334 25.8458 4.84015 25.868 4.75162C25.8882 4.66205 25.91 4.57286 25.9337 4.48394C25.9583 4.39579 25.9877 4.30958 26.0163 4.22259C26.0313 4.17935 26.0458 4.13611 26.0616 4.09314C26.0778 4.05042 26.0947 4.00847 26.1118 3.96627C26.1462 3.88199 26.1809 3.79745 26.219 3.71511L26.2777 3.59224L26.3382 3.47002C26.5057 3.14788 26.698 2.83929 26.9203 2.55174C27.0314 2.4077 27.15 2.26935 27.2771 2.13719C27.3095 2.1044 27.3413 2.07136 27.3743 2.03936C27.408 2.00761 27.4407 1.9756 27.4758 1.94488C27.5444 1.88267 27.6156 1.82253 27.6931 1.76807Z",
    fill: "white"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3757 2.02783C31.3466 2.21484 31.303 2.39127 31.2585 2.5668C31.2122 2.74116 31.1623 2.91269 31.1081 3.0815C31.0004 3.41952 30.8805 3.74889 30.7529 4.07464C30.625 4.40053 30.4942 4.72293 30.3491 5.04378C30.3148 5.1247 30.2788 5.20498 30.2408 5.28525L30.2117 5.3454L30.1843 5.40593L30.1278 5.52712C30.0888 5.60778 30.0468 5.68845 30.0079 5.77027C29.9679 5.85197 29.9253 5.93392 29.8753 6.01549C29.8598 5.9227 29.852 5.82977 29.8467 5.73659C29.8437 5.68974 29.841 5.64314 29.842 5.59681C29.8423 5.55099 29.8443 5.50466 29.8452 5.45846C29.8505 5.36656 29.8522 5.27312 29.8651 5.18252C29.876 5.0914 29.8886 5.00054 29.9035 4.90968C29.9187 4.81946 29.9388 4.73054 29.9586 4.64097C29.9689 4.5967 29.9791 4.55179 29.9903 4.50791C30.0022 4.4639 30.0148 4.42001 30.0274 4.37639C30.0532 4.28914 30.0786 4.20125 30.1083 4.1153L30.1542 3.98714L30.2021 3.85962C30.3353 3.52199 30.4955 3.19546 30.6869 2.88662C30.7826 2.732 30.8868 2.5819 30.9997 2.43761C31.0285 2.40186 31.0565 2.36559 31.0863 2.33048C31.1164 2.29551 31.1461 2.26015 31.1774 2.22607C31.2396 2.15741 31.304 2.0903 31.3757 2.02783Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3780_17935",
    x: 0.705078,
    y: 0.705566,
    width: 48.5898,
    height: 96.0308,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3780_17935"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3780_17935",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3780_17935",
    x1: 22.6599,
    y1: 90.2123,
    x2: 23.0187,
    y2: 81.6419,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5F3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.895833,
    stopColor: "#FFBF08"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicIcon);
export default __webpack_public_path__ + "static/media/mic-icon.4f0c005c503c7027030bde0c522481b0.svg";
export { ForwardRef as ReactComponent };